<template>
  <q-layout
    view="lHh Lpr lFf"
    :class="['analytics-layout', { 'qlayout--clip': clipPageScroll }]"
    @keydown.esc="onEscKeydown"
  >
    <q-splitter
      v-if="RA && (WLoadA || rootstore.generalMode !== 6) && (StorageRA || ![7,8].includes(rootstore.generalMode))"
      v-model="splitterModel.outer"
      unit="px"
      emit-immediately
      :class="splitterClass"
      @update:model-value="onChange"
    >
      <!-- separator-class="horizontal-sep" -->
      <template #before>
        <q-drawer
          v-model="leftDrawerOpen"
          show-if-above
          bordered
          class="white"
          :width="drawerWidth"
          :breakpoint="0"
        >
          <!-- breakpoint is needed or force behavior to desktop otherwise on small screen will enforce an overlay 
            because it will go to mobile mode which is the normal behavior -->
          <div
            v-show="!bottomExpand"
            class="list-toolbar"
            :class="{ 'list-toolbar--search': genstore.globalFilterMode }"
          >
            <button
              v-if="rootstore.generalMode < 100"
              ref="plus_menu_anchor"
              class="toolbar-icon-btn toolbar-icon-btn--accent toolbar-icon-btn--add"
              :class="{ 'toolbar-icon-btn--active-add': plusMenuOpen }"
              :aria-label="$t('create_root')"
              @mouseenter="openPlusMenu"
              @mouseleave="onPlusButtonLeave"
              @click.stop="togglePlusMenu"
            >
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 8C16.5523 8 17 8.44772 17 9C17 9.55229 16.5523 10 16 10H2C1.44772 10 1 9.55229 1 9C1 8.44772 1.44772 8 2 8H16ZM9 1C9.55229 1 10 1.44772 10 2V16C10 16.5523 9.55229 17 9 17C8.44772 17 8 16.5523 8 16V2C8 1.44772 8.44772 1 9 1Z" fill="currentColor"/>
              </svg>
              <q-tooltip v-if="!plusMenuOpen" :delay="300">
                {{ $t("create_root") }}
              </q-tooltip>
            </button>
            <mosta-context-menu
              :visible="plusMenuOpen"
              :position="plusMenuPos"
              :min-width="180"
              :disable-backdrop-pointer="true"
              menu-class="plus-context-menu"
              @close="plusMenuOpen = false"
              @menuEnter="onPlusMenuEnter"
              @menuLeave="onPlusMenuLeave"
            >
              <div class="plus-context-menu__item" @click="onPlusMenuCreateFolder">
                {{ $t('create_folder') }}
              </div>
              <div class="plus-context-menu__sep"></div>
              <div class="plus-context-menu__item" @click="onPlusMenuCreateSelection">
                {{ $t('create_selection') }}
              </div>
              <template v-if="canShowPlusChartItems">
                <div class="plus-context-menu__sep"></div>
                <div class="plus-context-menu__item" @click="onPlusMenuCreateChart(chartMenuTypes.GRAPH)">
                  {{ $t('add_linear_chart') }}
                </div>
                <div class="plus-context-menu__item" @click="onPlusMenuCreateChart(chartMenuTypes.PIE_CHART)">
                  {{ $t('add_pie_chart') }}
                </div>
                <div class="plus-context-menu__item" @click="onPlusMenuCreateChart(chartMenuTypes.BAR_CHART)">
                  {{ $t('add_bar_chart') }}
                </div>
              </template>
            </mosta-context-menu>
            <div class="toolbar-input-wrapper">
              <segment-selector
                v-show="!genstore.globalFilterMode"
                class="full-width toolbar-segment-selector"
                :mode="rootstore.generalMode"
                :data="rootstore.generalSelector"
                @change="changeMode"
              />
              <q-input
                hide-bottom-space
                outlined
                dense
                color="white"
                v-show="genstore.globalFilterMode"
                ref="panel_search_input"
                autofocus
                @keydown.esc="
                  genstore.setGlobalFilterMode(false);
                  filter_string = '';
                "
                class="full-width toolbar-search-input"
                v-model="filter_string"
                debounce="150"
                clearable
                :clear-icon="clearIconName"
              />
            </div>
            <button
              class="toolbar-icon-btn toolbar-icon-btn--accent toolbar-icon-btn--search"
              :class="{ 'toolbar-icon-btn--active-search': genstore.globalFilterMode }"
              @click="genstore.setGlobalFilterMode(!genstore.globalFilterMode); focusSearch()"
              :aria-label="$t('filter')"
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.5005 17.5L13.8838 13.8833" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <q-tooltip :delay="300">
                {{ $t('search_short') }}
              </q-tooltip>
            </button>
            <button
              class="toolbar-icon-btn toolbar-icon-btn--accent toolbar-icon-btn--fav"
              :class="{ 'toolbar-icon-btn--active-fav': genstore.favoriteMode }"
              @click="genstore.setFavoriteFilterMode(!genstore.favoriteMode)"
              :aria-label="$t('favorite')"
            >
              <svg width="18" height="18" viewBox="29.5 2.5 16.5 14.5" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M30.7773 7.83935C30.7774 7.03566 31.0212 6.25088 31.4765 5.58866C31.9319 4.92645 32.5775 4.41794 33.3279 4.13031C34.0784 3.84268 34.8984 3.78946 35.6798 3.97767C36.4611 4.16588 37.167 4.58667 37.7042 5.18446C37.742 5.22492 37.7877 5.25717 37.8385 5.27922C37.8894 5.30127 37.9442 5.31265 37.9995 5.31265C38.0549 5.31265 38.1097 5.30127 38.1605 5.27922C38.2114 5.25717 38.2571 5.22492 38.2949 5.18446C38.8304 4.58278 39.5364 4.15846 40.319 3.96796C41.1017 3.77746 41.9237 3.82983 42.6758 4.11809C43.4279 4.40636 44.0744 4.91685 44.5292 5.58161C44.984 6.24638 45.2256 7.0339 45.2217 7.83935C45.2217 9.49323 44.1384 10.7282 43.0551 11.8116L39.0887 15.6487C38.9541 15.8033 38.7882 15.9274 38.6019 16.0129C38.4157 16.0984 38.2134 16.1433 38.0084 16.1446C37.8035 16.1459 37.6006 16.1036 37.4133 16.0205C37.226 15.9373 37.0585 15.8153 36.922 15.6624L32.944 11.8116C31.8607 10.7282 30.7773 9.50045 30.7773 7.83935Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <q-tooltip :delay="300">
                {{ $t("favorite") }}
              </q-tooltip>
            </button>
            <button
              class="toolbar-icon-btn toolbar-icon-btn--expand"
              @click="setUpperExpand(!upperExpand)"
            >
              <svg width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg" :style="upperExpand ? 'transform: rotate(180deg)' : ''">
                <path d="M4.33008 5.25L8.66021 0H-4.91142e-05L4.33008 5.25Z" fill="currentColor"/>
              </svg>
            </button>
          </div>
          <div
            class="row no-wrap q-py-xs q-px-md"
            v-if="
              bottomExpand && genstore.selectedItem && genstore.selectedItem.Id
            "
          >
            <q-icon
              v-if="genstore.selectedItem && genstore.selectedItem.elType === 0"
              color="accent"
              name="grid_view"
              style="margin-right: 1px"
              size="xs"
            />
            <q-icon
              v-if="genstore.selectedItem && genstore.selectedItem.elType === 1"
              color="accent"
              name=""
              style="margin-right: 3px; margin-top: 4px"
              size="xs"
            />
            <q-icon
              v-if="genstore.selectedItem && genstore.selectedItem.elType === 2"
              color="accent"
              name="show_chart"
              style="margin-right: 3px; margin-top: 4px"
              size="xs"
            />
            <q-icon
              v-if="genstore.selectedItem && genstore.selectedItem.elType === 3"
              color="accent"
              name="pie_chart_outline"
              style="margin-right: 3px; margin-top: 4px"
              size="xs"
            />
            <q-icon
              v-if="genstore.selectedItem && genstore.selectedItem.elType === 4"
              color="accent"
              name="bar_chart"
              style="margin-right: 3px; margin-top: 4px"
              size="xs"
            />
            <q-icon
              v-if="
                genstore.selectedItem && genstore.selectedItem.elType === 901
              "
              color="accend"
              name="height"
              style="margin-right: 3px; margin-top: 4px"
              size="xs"
            />
            <div class="q-ml-sm">
              {{
                genstore.selectedItem ? genstore.selectedItem.CombinedName : ""
              }}
            </div>
          </div>

          <q-splitter
            v-model="splitterModel.inner"
            :limits="[0, 100]"
            :style="`height: calc(100% - ${
              bottomExpand ? 37 : upperExpand ? 63 : 62
            }px);`"
            horizontal
          >
            <!-- separator-class="vertical-sep" -->
            <template v-slot:before>
              <div
                v-if="!genstore.isLoading"
                class="full-height"
              >
              <DndProvider :backend="HTML5Backend" :context="_DND_WINDOW_">
              <CustomDragLayer
                :selected-items="$refs.virtualListRef?.selectedItems"
                :flat-items="$refs.virtualListRef?.flatItems"
                :effective-count="$refs.virtualListRef?.effectiveSelectedCount"
              />
              <div class="full-height" style="display: flex; gap: 0;">
                <virtual-analytics-list
                  ref="virtualListRef"
                  style="flex: 1; min-width: 0; border-left: 1px solid #e0e0e0;"
                  :input-items="currentInputItems"
                  :search-string="filter_string"
                  :favorite-mode="genstore.favoriteMode"
                  :pending-create-folder-by-parent="pendingCreateFolderByParent"
                  :pending-move-by-key="pendingMoveByKey"
                  :between-root-drop-via-indicator="true"
                  @changeParent="moveItemToParent"
                  @cardSelected="onItemSelected"
                  @cardDeleted="onRequestItemDelete"
                  @cardFavorite="onItemFavorite"
                  @cardCloned="onItemCloned"
                  @cardRenamed="onItemRenamed"
                  @addChildSelection="addChildSelection"
                  @addChildProjection="addChildProjection"
                  @addChildList="openCreateList"
                  @addChildChart="addChildChart"
                  @addChildFolder="addChildFolder"
                  @addToReport="openAddToReport"
                  @deleteSelected="onDeleteSelected"
                  @breakAfter="onBreakAfter"
                  @changePosition="moveStoreItem"
                  @cardMoved="moveCard"
                />
              </div>
              <ConfirmActionPopup
                v-if="confirmPopup.show"
                :title="confirmPopup.title"
                :question="confirmPopup.question"
                :highlight="confirmPopup.highlight"
                :question-html="confirmPopup.questionHtml"
                :position="confirmPopup.position"
                :confirm-label="confirmPopup.confirmLabel"
                :cancel-label="confirmPopup.cancelLabel"
                @confirm="confirmPopup.onConfirm"
                @cancel="confirmPopup.onCancel"
              />
              </DndProvider>
              </div>
              <div
                v-else
                style="
                  height: 100%;
                  max-height: 100%;
                  text-align: center;
                  padding-top: 20px;
                "
              >
                <q-spinner-dots color="primary" size="2em" />
              </div>

              <!-- Add to report dialogs -->
              <q-dialog v-model="addToReportDialog">
                <q-card>
                  <q-card-section>
                    <div class="text-subtitle2">{{ $t("select_report") }}</div>
                  </q-card-section>
                  <q-separator />

                  <q-card-section>
                    <q-select
                      flat
                      v-model="reportIdsModel"
                      multiple
                      outlined
                      option-label="Name"
                      option-value="Id"
                      :label="
                        reportIdsModel.length ? '' : $t('create_report_and_add')
                      "
                      :options="reportOptions"
                    >
                      <template v-slot:no-option>
                        <q-item>
                          <q-item-section class="text-grey">
                            {{ $t("no_data_found") }}
                          </q-item-section>
                        </q-item>
                      </template>
                    </q-select>
                  </q-card-section>

                  <q-separator />

                  <q-card-actions align="right">
                    <q-btn
                      flat
                      size="sm"
                      :label="$t('cancel')"
                      color="dark"
                      v-close-popup
                    />
                    <q-btn
                      flat
                      size="sm"
                      :label="$t('do_action')"
                      @click="addToReport"
                      autofocus
                      color="dark"
                      v-close-popup
                    />
                  </q-card-actions>
                </q-card>
              </q-dialog>

              <!-- Create list confirm dialog -->
              <q-dialog v-model="createListDialog">
                <q-card>
                  <q-card-section>
                    <div class="text-subtitle2">{{ $t("create_list") }}</div>
                  </q-card-section>
                  <q-separator />

                  <q-card-section>
                    <div
                      v-if="genstore.isLoading"
                      class="q-mr-sm"
                      style="word-wrap: keep-all"
                    >
                      {{ $t("precalculation") }}
                    </div>
                    <div v-else class="q-mr-sm" style="word-wrap: keep-all">
                      {{ $t("create_list_promt_1") }}&nbsp;
                      {{ genstore.getPrecalcCount }}&nbsp;{{
                        [0, 6].includes(tempListBase.hoverParams.elType)
                          ? $t("create_list_promt_2_sel")
                          : $t("create_list_promt_2_proj")
                      }}?
                    </div>
                  </q-card-section>

                  <q-separator />

                  <q-card-actions
                    v-if="!genstore.isLoading && genstore.getPrecalcCount"
                    align="right"
                  >
                    <q-btn
                      flat
                      size="sm"
                      :label="$t('cancel')"
                      color="dark"
                      v-close-popup
                    />
                    <q-btn
                      flat
                      size="sm"
                      :label="$t('do_action')"
                      @click="addChildList"
                      color="dark"
                      autofocus
                      v-close-popup
                    />
                  </q-card-actions>
                </q-card>
              </q-dialog>

              <!-- storage mode dialogs -->
              <q-dialog
                v-model="createMovementMode"
                persistent no-shake
                :full-width="true"
              >
                <movement-create-component
                  :create-type="createMoveType"
                  @close="createMovementMode = false"
                  :container-for-preload="containerForNewMovement"
                />
              </q-dialog>
              <q-dialog
                v-model="createStorageItemMode"
                no-shake
                :full-width="false"
              >
                <item-addition-component
                  @close="createStorageItemMode = false"
                />
              </q-dialog>
              <q-dialog
                v-model="editStoragesMode"
                no-shake
                :full-width="false"
              >
                <storages-edit-component @close="editStoragesMode = false" />
              </q-dialog>
              <q-dialog
                v-model="editFinancesMode"
                persistent no-shake
                :full-width="true"
              >
                <project-data-component @close="editFinancesMode = false" />
              </q-dialog>
              <!-- <counterparty-change-dialog /> -->
            </template>
            <template v-slot:after>
              <div
                v-if="!setstore.isLoading"
                style="
                  min-height: 100%;
                  max-height: 100%;
                  overflow: hidden;
                  display: flex;
                  flex-flow: column;
                "
              >
                <div
                  v-show="!upperExpand"
                  class="row bg-white no-wrap justify-between"
                >
                  <q-tabs
                    v-model="tab"
                    dense
                    class="analytics-tabs bg-white"
                    align="justify"
                  >
                    <q-tab name="filters" no-caps :label="$t('settings')" :ripple="false" />
                    <q-tab name="columns" no-caps :label="$t('appearance')" :ripple="false" />
                    <!-- <q-tab v-if="genstore.selectedItem && genstore.selectedItem.ElementId && genstore.selectedItem.elType !== 901" name="other" :label="$t('screen')" /> -->
                  </q-tabs>

                  <q-space />
                  <button
                    v-if="
                      genstore.selectedItem &&
                      genstore.selectedItem.Id &&
                      [0, 1, 6].includes(genstore.selectedItem.elType) &&
                      tab === 'filters'
                    "
                    class="toolbar-icon-btn toolbar-icon-btn--accent"
                    style="padding: 0 6px; margin-right: 2px;"
                    :disabled="setstore.isSaving || querystore.isLoading"
                    :aria-label="$t('clear_filter')"
                    @click="resetAllFilters"
                  >
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 14.25L3.75 9L9 3.75" stroke="currentColor" stroke-width="1.6875" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M14.25 9H3.75" stroke="currentColor" stroke-width="1.6875" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <q-tooltip :delay="300">{{ $t('clear_filter') }}</q-tooltip>
                  </button>
                  <q-btn
                    v-if="genstore.selectedItem && genstore.selectedItem.Id"
                    :disable="
                      setstore.isSaving ||
                      graphstore.isSaving ||
                      querystore.isLoading ||
                      filtersIncorrect ||
                      chartsIncorrect
                    "
                    class="q-my-none splitter-refresh-btn"
                    flat
                    dense
                    round
                    icon="refresh"
                    size="md"
                    color="grey-6"
                    @click="getQueryResult"
                    :aria-label="$t('result')"
                  >
                    <q-tooltip
                      v-if="
                        setstore.isSaving ||
                        graphstore.isSaving ||
                        querystore.isLoading ||
                        filtersIncorrect ||
                        chartsIncorrect
                      "
                      :delay="300"
                    >
                      {{
                        setstore.isSaving ||
                        graphstore.isSaving ||
                        querystore.isLoading
                          ? $t("loading")
                          : filtersIncorrect || chartsIncorrect
                          ? $t("filters_error_fix_before_update")
                          : $t("unavailable")
                      }}
                    </q-tooltip>
                    <q-tooltip v-else :delay="300">
                      {{ $t('refresh_label') }}
                    </q-tooltip>
                  </q-btn>
                  <!-- <q-btn v-if="genstore.selectedItem && [0,1].includes(genstore.selectedItem.elType) &&
                  !querystore.isLoading && querystore.getCurrentTable && querystore.getCurrentTable.HeaderRow"
                    class="q-my-none q-py-xs" flat dense round size="md" color="grey-6"
                    @click="saveTableToFile(genstore.selectedItem, genstore.selectedItem ? genstore.selectedItem.Name : '')"
                    :aria-label="$t('load')"
                  >
                    <div class="download-btn" />
                  </q-btn> -->
                  <button
                    class="toolbar-icon-btn toolbar-icon-btn--splitter-expand"
                    style="padding: 0 10px;"
                    @click="setBottomExpand(!bottomExpand)"
                  >
                    <svg width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg" :style="bottomExpand ? '' : 'transform: rotate(180deg)'">
                      <path d="M4.33008 5.25L8.66021 0H-4.91142e-05L4.33008 5.25Z" fill="currentColor"/>
                    </svg>
                  </button>
                </div>
                <q-separator />
                <q-tab-panels
                  v-model="tab"
                  class="full-height bg-white scroll q-pa-xs settings-panels-scroll"
                >
                  <q-tab-panel
                    name="filters"
                    class="left-panel bg-white full-height q-pa-xs"
                  >
                    <projection-settings-panel
                      v-for="(filter, f_index) in setstore.getProjectionFilters"
                      :key="'pf_' + f_index"
                      :element="genstore.selectedItem"
                      :parent-chain="setstore.getProjectionParentChain"
                      v-model="setstore.getProjectionFilters[f_index]"
                    />
                    <base-chart-panel
                      v-if="
                        graphstore?.getCurrentSettings && 
                        (genstore.selectedItem.elType === 2 ||
                        genstore.selectedItem.elType === 3 ||
                        genstore.selectedItem.elType === 4)
                      "
                      :key="'graph_'+genstore.selectedItem.Id+'_'+genstore.selectedItem.elType+'_'+graphstore.getCurrentSettings?.Descriptor"
                      v-model="graphstore.getCurrentSettings"
                    />
                    <analytics-filter-list
                      v-else
                      :input-items="setstore.getCurrentFilters"
                    />
                  </q-tab-panel>
                  <q-tab-panel
                    ref="bottom_scroll_panel"
                    name="columns"
                    class="left-panel bg-white full-height"
                    style="overflow-x: hidden"
                  >
                    <report-element-settings-panel
                      v-if="
                        genstore.selectedItem &&
                        genstore.selectedItem.ElementId &&
                        genstore.selectedItem.elType !== 901
                      "
                      :model-value="genstore.selectedItem"
                    />

                    <formulas-list
                      v-if="
                        setstore.getSelectedColumns &&
                        genstore.selectedItem &&
                        [0, 1].includes(genstore.selectedItem.DestType) &&
                        ![2, 3, 4].includes(genstore.selectedItem.elType)
                      "
                      v-model="setstore.tableFormulas"
                      :parameter-options="graphstore.getCurrentFormulas"
                      nested-key-name="ChildFormulas"
                      template-name="Entity"
                      @changePosition="moveFormulaItem"
                    />

                    <element-options-settings-panel
                      v-if="
                        setstore.getProjectionOptions &&
                        setstore.getProjectionOptions.length &&
                        ![2, 3, 4].includes(genstore.selectedItem.elType)
                      "
                      v-model="setstore.getProjectionOptions"
                    />

                    <div
                      class="row no-wrap full-width"
                      style="border-bottom: 1px solid #eaeaea"
                    >
                      <div class="q-py-xs">{{ $t("columns_header") }}</div>
                      <q-space />
                      <q-btn
                        v-if="setstore.getSelectedColumns && tab === 'columns'"
                        :disable="
                          !groupMode || compound_ids.length > 1 ? false : true
                        "
                        class="q-mt-none q-mb-xs"
                        flat
                        dense
                        no-caps
                        color="grey-6"
                        @click="onGroupClick"
                        :aria-label="$t('combining')"
                      >
                        {{ !groupMode ? $t("combining") : $t("combine") }}
                      </q-btn>
                      <q-btn
                        v-if="
                          setstore.getSelectedColumns &&
                          groupMode &&
                          tab === 'columns'
                        "
                        class="q-mt-none q-mb-xs"
                        flat
                        dense
                        no-caps
                        color="grey-6"
                        @click="onCancelGroupClick"
                        :aria-label="$t('cancel')"
                      >
                        {{ $t("cancel") }}
                      </q-btn>
                    </div>
                    <selected-settings-list
                      :input-items="setstore.getSelectedColumns"
                      @changePosition="moveColumnItem"
                      @changeSelection="onColumnSelected"
                      @groupChange="addToGroup"
                      @togglesChange="onTogglesChange"
                      @rangeChange="onRangeChange"
                      @unGroupClick="onUnGroupClick"
                      @unGroupSingleClick="onUnGroupSingleClick"
                      :groupingMode="groupMode"
                    />
                    <analytics-settings-list
                      :input-items="setstore.getNonSelectedColumns"
                      @changeSelection="onColumnSelected"
                    />

                    <q-btn
                      v-if="this.genstore.selectedItem && this.genstore.selectedItem.Id"
                      flat
                      class="q-mt-sm"
                      size="sm"
                      :label="$t('make_default_settings')"
                      color="dark"
                      @click="setDefSettingsClick"
                    />
                  </q-tab-panel>
                  <!-- <q-tab-panel v-if="genstore.selectedItem && genstore.selectedItem.ElementId && genstore.selectedItem.elType !== 901" name="other" class="left-panel bg-grey-2 full-height">
                    
                  </q-tab-panel> -->
                </q-tab-panels>
              </div>
              <div
                v-else
                style="
                  height: 100%;
                  max-height: 100%;
                  text-align: center;
                  padding-top: 20px;
                "
              >
                <q-spinner-dots color="primary" size="2em" />
              </div>
            </template>
          </q-splitter>
        </q-drawer>
      </template>
      <template v-slot:separator>
        <q-btn
          flat
          dense
          round
          style="
            position: relative;
            right: 6px;
            top: 50vh;
            color: grey;
            background-color: white;
            transform: rotate(90deg) translateY(12px);
            width: 10px;
            height: 20px;
            border: 1px solid lightgrey;
            border-radius: 1px;
          "
          @click="drawerButtonClick"
          :icon="leftDrawerOpen ? 'arrow_drop_down' : 'arrow_drop_up'"
          size="sm"
        />
      </template>
      <template #after>
        <div class="analytics-page-container" :style="compPadding">
          <div
            class="analytics-page"
            :class="{ 'qpage--table-flex': (querystore.getCurrentTable && querystore.getCurrentTable.HeaderRow) || showTableSkeleton, 'qpage--clip': clipPageScroll }"
            :style="`padding: 6px; background: ${
              (querystore.getCurrentTable && querystore.getCurrentTable.HeaderRow) || showTableSkeleton ? '#F2F2F2' : '#fff'
            };`"
          >
            <!-- <div class="q-pa-xs" :style="`position: absolute; top: 0; background: transparent; width: 99%; color: ${graphstore.elementsUpdated ? 'green' : '#f57c00'};`">
              {{ graphstore.elementsUpdated ? 'Данные по кривым обновлены' : 'Данные по кривым в кэше и не сохранены в БД' }}</div> -->

            <!-- storage actions -->
            <div
              v-if="[7, 8].includes(rootstore.generalMode)"
              class="row justify-between q-pa-sm no-wrap"
              :style="'width: 100%; min-width: 880px; background: white;'"
            >
              <div
                :class="!StorageWA ? 'text-h8 text-grey-6' : 'text-h8 cursor-pointer'"
                style="text-decoration: underline !important"
                @click="StorageWA && (createStorageItemMode = true)"
              >
                {{ $t('add_warehouse_position') }}
              </div>
              <div
                :class="(!StorageWA ? 'text-grey-6' : 'cursor-pointer')+' text-h8 no-break movement-element movement-element--income'"
                @click="
                  () => {
                    if (!StorageWA) { return }
                    createMoveType = 0;
                    if (!containerForNewMovement || (containerForNewMovement && selectedCount <= 500)) {
                      createMovementMode = true;
                    } else {
                      alert($t('movement_max_positions'))
                    }
                  }
                "
              >
                <span style="text-decoration: underline !important"
                  >{{ $t('income_label') }}</span
                >
              </div>
              <div
                :class="(!StorageWA ? 'text-grey-6' : 'cursor-pointer')+' text-h8 no-break movement-element movement-element--expense'"
                @click="
                  () => {
                    if (!StorageWA) { return }
                    
                    createMoveType = 1;
                    if (!containerForNewMovement || (containerForNewMovement && selectedCount <= 500)) {
                      createMovementMode = true;
                    } else {
                      alert($t('movement_max_positions'))
                    }
                  }
                "
              >
                <span style="text-decoration: underline !important"
                  >{{ $t('expense_label') }}</span
                >
              </div>
              <div
                :class="(!StorageWA ? 'text-grey-6' : 'cursor-pointer')+' text-h8 no-break movement-element movement-element--transfer'"
                @click="
                  () => {
                    if (!StorageWA) { return }

                    createMoveType = 2;
                    if (!containerForNewMovement || (containerForNewMovement && selectedCount <= 500)) {
                      createMovementMode = true;
                    } else {
                      alert($t('movement_max_positions'))
                    }
                  }
                "
              >
                <span style="text-decoration: underline !important"
                  >{{ $t('transfer_label') }}</span
                >
              </div>
              <div
                :class="!StorageWA ? 'text-h8 text-grey-6' : 'text-h8 cursor-pointer'"
                style="text-decoration: underline !important"
                @click="StorageWA && (editStoragesMode = true)"
              >
                {{ $t('edit_warehouses') }}
              </div>
              <!-- <div
                class="text-h8 cursor-pointer"
                style="text-decoration: underline !important"
                @click="editFinancesMode = true"
              >
                {{ $t('one_c') }} - {{ $t('finances_lower') }}
              </div> -->
            </div>

            <div
              v-if="showTableSkeleton"
              style="width: 100%; flex: 1 1 0; min-height: 0"
            >
              <QTLiteSkeleton />
            </div>
            <div
              v-if="
                !switchingElement &&
                !querystore.isLoading &&
                !(
                  querystore.getCurrentGraph &&
                  (querystore.getCurrentGraph.CurveResults ||
                    querystore.getCurrentGraph.BarChartResults ||
                    querystore.getCurrentGraph.PieChartResults)
                ) &&
                !(
                  querystore.getCurrentTable &&
                  querystore.getCurrentTable.HeaderRow
                ) &&
                !(
                  querystore.getCurrentReport &&
                  querystore.getCurrentReport.length
                )
              "
              class="q-mx-auto q-my-auto empty-label"
            >
              {{ $t("analytics_header") }}
            </div>
            <q-toolbar v-if="false">
              <q-btn
                flat
                dense
                round
                @click="drawerButtonClick"
                aria-label="Menu"
                icon="menu"
              />

              <q-toolbar-title> Quasar App </q-toolbar-title>

              <div>Quasar v{{ $q.version }}</div>
            </q-toolbar>

            <!-- Главная таблица. QueryTable.vue рендерит lite-таблицу (QueryTableLite). -->


            <query-table
              v-if="
                querystore.getCurrentTable &&
                querystore.getCurrentTable.HeaderRow
              "
              v-show="!querystore.isLoading || keepLiteTableVisibleOnLoading"
              v-model="querystore.getCurrentTable"
              :src-element="genstore.selectedItem"
              :paginationModel="pagination"
              @update:paginationModel="onUpdatePagination"
              :selectedEverything="selectedAll"
              @update:selectedEverything="onSelectedAllUpdate"
              :selectedEntities="selectedEntities"
              @update:selectedEntities="onSelectionUpdate"
              :unselectedEntities="unselectedEntities"
              @update:unselectedEntities="onUnSelectionUpdate"
              @selectionChangeManual="updatePinned"
              @refreshPage="onRefreshTable"
              @reloadTable="getQueryResult"
            />

            <!-- <div  style="width: 99%; height: 70vh;"> -->
            <query-chart
              v-if="
                !querystore.isLoading &&
                querystore.getCurrentGraph &&
                (querystore.getCurrentGraph.CurveResults ||
                  querystore.getCurrentGraph.BarChartResults ||
                  querystore.getCurrentGraph.PieChartResults)
              "
              v-model="querystore.getCurrentGraph"
              :src-element="{
                ChartId: genstore.selectedItem.Id,
                ChartType:
                  genstore.selectedItem.elType === 2
                    ? 0
                    : genstore.selectedItem.elType === 3
                    ? 1
                    : 2,
                Destination: genstore.selectedItem.DestType,
              }"
              @refreshChart="getQueryResult"
            />
            <!-- </div> -->

            <div
              class="q-mx-auto"
              style="width: 99%; height: 99%; position: relative"
              v-if="querystore.getCurrentReport"
            >
              <div
                v-for="(report, rep_index) in querystore.getCurrentReport"
                :key="'ri_' + rep_index"
              >
                <query-table-preview
                  v-model="querystore.getCurrentReport[rep_index]"
                  v-if="[0, 1, 6].includes((report as QueryResultItem).elementType) && 
                    (report as QueryResultItem).Element && 
                    ((report as QueryResultItem).Element as AnalyticsResultTableExtended).HeaderRow"
                />
                <query-chart-preview
                  v-model="querystore.getCurrentReport[rep_index]"
                  v-if="[2, 3, 4].includes((report as QueryResultItem).elementType) && 
                    (report as QueryResultItem).Element && 
                    (((report as QueryResultItem).Element as any).CurveResults || 
                    ((report as QueryResultItem).Element as any).BarChartResults || 
                    ((report as QueryResultItem).Element as any))"
                />
                <report-break-preview
                  v-if="[901].includes((report as QueryResultItem).elementType) && (report as QueryResultItem).elementItem"
                  :input-text="((report as QueryResultItem).elementItem as BaseListItem).Name || ''"
                />
              </div>
            </div>
          </div>
        </div>
      </template>
    </q-splitter>
    <div v-else class="q-mx-auto q-my-auto empty-label">
      {{ $t("no_access") }}
    </div>
  </q-layout>
</template>

<script lang="ts">
/** Центральный компонент аналитики. Когда появятся другие разделы (склад, клиент, проект, настройки и т.п.),
 * нужно будет прикручивать роутинг. Пока что его нет
 */

// system
import { i18n } from "@/i18n";
import { useDebounceFn } from "@vueuse/core";
import { reactive } from "vue";
// import * as htmlToImage from 'html-to-image';
// import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';
// types
import { Component, Vue, Watch } from "vue-facing-decorator";
import { useRoute, useRouter } from "vue-router";
import { rootStore } from "@/store/index";
import { generalStore } from "@/store/general";
import {
  AnalyticsV2ChartType,
  AnalyticsV2ElementType,
  ColumnSendTypeDescriptor,
  V2StorageItemMovementType,
} from "@/models/etc/types";
import {
  AnalyticsRequestData,
  MultiEditEntityContainer,
  PinnedEntitiesSetRequest,
} from "@/store/interfaces/types.analytics";
import { BaseItemTypes } from "@/components/dnd/ItemTypes";
import { PaginationProps } from "@/models/base/common.selector";

// stores
import { settingsStore } from "@/store/settings";
import { queryStore } from "@/store/querytable";
import { graphSettingsStore } from "@/store/graph";
import { multiEditStore } from "@/store/multiedit";
import _, { filter } from "lodash";
import BaseChartPanel from "@/components/charts/BaseChartPanel.vue";
import {
  AnalyticsChartIdentity,
  AnalyticsElementIdentity,
  AnalyticsElementKind,
} from "@/models/interfaces/entity-settings/charts/charts";
import {
  BaseListItem,
  ColumnGroupItem,
  getIdentityKind,
  QueryResultItem,
} from "@/components/common/base-list/interfaces/ListTypes";
import { CommonEntity } from "@/models/interfaces/common";
import { auxStore } from "@/store/auxillary";
import { workerStore } from "@/store/worker";

// components
import SegmentSelector from "@/components/common/segment.selector.vue";
import VirtualAnalyticsList from "@/components/common/base-list/VirtualAnalyticsList.vue";
import ConfirmActionPopup from "@/components/common/basic/confirm/ConfirmActionPopup.vue";
import { DndProvider } from 'vue3-dnd';
import CustomDragLayer from '@/components/dnd/CustomDragLayer.vue';
import SelectedSettingsList from "@/components/common/settings-list/SelectedSettingsList.vue";
import AnalyticsSettingsList from "@/components/common/settings-list/AnalyticsSettingsList.vue";
import ReportElementSettingsPanel from "@/components/common/settings-list/ReportElementSettingsPanel.vue";
import ProjectionSettingsPanel from "@/components/common/settings-list/ProjectionSettingsPanel.vue";
import AnalyticsFilterList from "@/components/common/filter-list/AnalyticsFilterList.vue";
import FormulasList from "@/components/common/formulas-list/FormulasList.vue";
import QueryTable from "@/components/common/querytable/QueryTable.vue";
import { liteHeaderModeFlag } from "@/components/common/querytable/refactored/featureFlag";
import QTLiteSkeleton from "@/components/common/querytable/refactored/QTLiteSkeleton.vue";
import QueryTablePreview from "@/components/common/querytable/QueryTablePreview.vue";
import QueryChart from "@/components/common/querychart/QueryChart.vue";
import QueryChartPreview from "@/components/common/querychart/QueryChartPreview.vue";
import ReportBreakPreview from "@/components/common/querytable/ReportBreakPreview.vue";
import MostaContextMenu from "@/components/common/basic/MostaContextMenu.vue";

// TEMPORARY TO DEBUG
import MovementCreateComponent from "@/components/multiedit/temporary/MovementCreateComponent.vue";
// import ItemAdditionComponent from "@/components/multiedit/temporary/ItemAdditionComponent.vue";
import StoragesEditComponent from "./components/multiedit/temporary/StoragesEditComponent.vue";

// TEMPORARY INFO DIALOGS
import CounterpartyChangeDialog from "@/components/multiedit/temporary/info-dialogs/CounterpartyChangeDialog.vue";
import { storageStore } from "./store/storage/storage-instances";
import { storagePositionsStore } from "./store/storage/storage-positions";
import ElementOptionsSettingsPanel from "./components/common/settings-list/ElementOptionsSettingsPanel.vue";
import ProjectDataComponent from "./components/multiedit/temporary/ProjectDataComponent.vue";
import { ColumnSendSelectable } from "./models/interfaces/entity-settings/columns/columns";
import { findRecursive, foreachRecursive } from "./models/helpers/recursive";

// default splitters dimensions
const default_outer_splitter = 350;
const default_inner_splitter = 50;
const splitter_close_threshold = 320;

// Локали (см. src/i18n/index.ts)
const SUPPORTED_LOCALES = ["ru", "en", "vi"];

@Component({
  name: "Analytics",
  components: {
    SegmentSelector,
    VirtualAnalyticsList,
    ConfirmActionPopup,
    DndProvider,
    CustomDragLayer,
    AnalyticsSettingsList,
    FormulasList,
    QueryChart,
    ReportBreakPreview,
    SelectedSettingsList,
    AnalyticsFilterList,
    QueryTable,
    BaseChartPanel,
    QueryChartPreview,
    QueryTablePreview,
    ReportElementSettingsPanel,
    ProjectionSettingsPanel,
    ElementOptionsSettingsPanel,
    MostaContextMenu,
    QTLiteSkeleton,

    // TEMPORARY TO DEBUG
    MovementCreateComponent,
    // ItemAdditionComponent,
    StoragesEditComponent,
    ProjectDataComponent,
    CounterpartyChangeDialog
  },
})
export default class Analytics extends Vue {
  /**
   * Видимость lite-таблицы во время загрузки определяется только наличием данных,
   * а НЕ флагом recalc. recalc — это серверный флаг пересчёта, к показу таблицы он
   * отношения не имеет. Сокрытие таблицы происходит только при смене элемента, когда
   * данные стираются через clearTable (тогда HeaderRow исчезает). Любая загрузка на
   * том же элементе (кнопка/мультиэдит/пагинация) таблицу не прячет — поверх идёт
   * тонкая полоска обновления.
   */
  get keepLiteTableVisibleOnLoading(): boolean {
    return !!(
      this.querystore?.getCurrentTable &&
      this.querystore?.getCurrentTable?.HeaderRow
    );
  }

  /**
   * Показываем ли скелетон таблицы: данных таблицы/отчёта ещё нет, но идёт загрузка
   * (или смена элемента). В этом состоянии q-page тоже переводим в flex-колонку,
   * чтобы скелетон тянулся до низа экрана, как настоящая таблица.
   */
  get showTableSkeleton(): boolean {
    // Может читаться из immediate-watcher clipPageScroll ещё в created, до присвоения сторов.
    if (!this.querystore) return false;
    return (
      (!this.querystore.getCurrentReport ||
        !this.querystore.getCurrentReport.length) &&
      !(
        this.querystore.getCurrentTable &&
        this.querystore.getCurrentTable.HeaderRow
      ) &&
      (this.querystore.isLoading || this.switchingElement)
    );
  }

  /**
   * Запрет прокрутки страницы под lite-таблицей в режимах sticky/scroll. В этих
   * режимах за вертикальную прокрутку отвечает само тело таблицы (внутренний скролл),
   * поэтому окно скроллиться не должно. Без запрета при сужении окна по высоте на
   * кадр успевает мелькнуть полоса прокрутки окна. В режиме page оставляем обычную
   * прокрутку страницы — там таблица растёт по содержимому и страница скроллится сама.
   * Условие наличия таблицы/скелетона совпадает с тем, по которому включается
   * qpage--table-flex, чтобы клип действовал ровно когда таблица занимает страницу.
   */
  get clipPageScroll(): boolean {
    // immediate-watcher onClipPageScrollChange читает этот геттер ещё в created, до того
    // как в created присвоены сторы, поэтому querystore может быть не готов — тогда клипа нет.
    const hasTable =
      (this.querystore?.getCurrentTable && this.querystore.getCurrentTable.HeaderRow) ||
      this.showTableSkeleton;
    return !!hasTable && liteHeaderModeFlag.value !== "page";
  }

  readonly chartMenuTypes = BaseItemTypes;

  createMovementMode = false;
  createStorageItemMode = false;
  editStoragesMode = false;
  editFinancesMode = false;
  HTML5Backend = require('react-dnd-html5-backend').HTML5Backend;
  _DND_WINDOW_ = window;

  createMoveType: V2StorageItemMovementType = V2StorageItemMovementType.In;

  // left splitter open
  leftDrawerOpen = false;
  // current settings tab
  tab = "filters";
  // horizontal and vertical splitter dimentions
  splitterModel = reactive({
    inner: default_inner_splitter,
    outer: default_outer_splitter,
  });
  // Флаг «идёт смена элемента списка». Нужен ТОЛЬКО чтобы на время смены показать
  // общий спиннер (три точки) и спрятать пустую подпись, пока запрос новой таблицы
  // ещё не стартовал (есть зазор: проверка saved-state + setTimeout). На видимость
  // самой таблицы (v-show/keepLiteTableVisibleOnLoading) НЕ влияет — таблицу убирает
  // clearTable, а возвращает её появление HeaderRow в данных. Сбрасывается, когда
  // загрузка завершилась (watcher) либо в ветках, где таблицы не будет.
  switchingElement: boolean = false;

  // В URL пришёл валидный ?lang= — язык задан явно и не должен перебиваться профилем.
  hasExplicitLang: boolean = false;

  // Роутер для синхронизации выбранного элемента с адресной строкой.
  router: any | undefined = undefined;

  // stores
  rootstore: any | undefined = undefined;
  genstore: any | undefined = undefined;
  setstore: any | undefined = undefined;
  graphstore: any | undefined = undefined;
  querystore: any | undefined = undefined;
  auxstore: any | undefined = undefined;
  storage: any | undefined = undefined;
  storage_pos: any | undefined = undefined;

  // store to refs in order to pass them to v-model: props
  // graphstore: any;
  // setstore: any;
  // querystore: any;
  // auxstore: any;

  // expand buttons mode
  upperExpand: boolean = false;
  bottomExpand: boolean = false;
  previousSplit: number = -1;

  // report confirm dialog show model
  addToReportDialog: boolean = false;
  // create list confirm dialog show model
  createListDialog: boolean = false;
  tempListBase: any = undefined;
  // Лок на создание вложенной папки по родителю: пока запрос не завершился, повтор по тому же parent блокируется.
  pendingCreateFolderByParent = reactive({} as Record<number, boolean>);
  // Request-only lock для перетаскивания: target + все перемещаемые элементы.
  pendingMoveByKey = reactive({} as Record<string, boolean>);

  private makeElementLockKey(arg: any): string {
    const elType = arg?.elType ?? "";
    const id = arg?.id ?? arg?.Id ?? "";
    const folderId = arg?.folderId ?? arg?.FolderId ?? "";
    const src = arg?.sourceDataType ?? arg?.SrcType ?? "";
    const dest = arg?.destinationDataType ?? arg?.DestType ?? "";
    // Для дочерних элементов в отчётах одна и та же сущность (Id+elType+SrcType+DestType)
    // может встречаться в разных отчётах; чтобы лочить только конкретную ссылку, добавляем её ElementId.
    const innerElementId = arg?.innerElementId ?? arg?.ElementId ?? "";
    return `${elType}:${id}:${folderId}:${src}:${dest}:${innerElementId}`;
  }

  private setMoveLocks(keys: string[]) {
    keys.forEach((k) => {
      if (k) this.pendingMoveByKey[k] = true;
    });
  }

  private clearMoveLocks(keys: string[]) {
    keys.forEach((k) => {
      if (k && this.pendingMoveByKey[k]) delete this.pendingMoveByKey[k];
    });
  }

  // reports list model for adding to
  reportIdsModel: CommonEntity[] = [];
  // reports list to choose from
  reportOptions: CommonEntity[] = [];
  // item being added to reportIdsModel
  itemToReport: BaseListItem | undefined = undefined;

  // analytics table items selection model
  selectedEntities: number[] = reactive([]);
  unselectedEntities: number[] = reactive([]);
  // top table chechbox
  selectedAll: string = "";

  // grouping columns and button mode in settings
  compound_ids: string[] = reactive([]);
  plusMenuOpen: boolean = false;
  plusMenuPos = reactive({ top: "0px", left: "0px" });
  private plusMenuCloseTimer: ReturnType<typeof setTimeout> | null = null;
  groupMode: boolean = false;
  // analytics table pagination properties
  pagination: PaginationProps = reactive({} as PaginationProps);

  // variable to determine if the current item is selected
  // after another of just being clicked
  old_arg: any = undefined;
  confirmPopup = reactive({
    show: false,
    title: "",
    question: "",
    highlight: "",
    questionHtml: "" as string,
    position: { x: 0, y: 0 },
    confirmLabel: undefined as string | undefined,
    cancelLabel: undefined as string | undefined,
    onConfirm: () => {},
    onCancel: () => {},
  });
  // top left panel search filter
  filter_string: string = "";

  private clearIconUrl: string = require("@/assets/arrow_back.svg");
  get clearIconName(): string { return `img:${this.clearIconUrl}`; }

  /** Источник элементов для главного списка: в сегменте «Отчёты» — список отчётов, иначе — общий унифицированный список. */
  get currentInputItems(): any[] {
    if (!this.genstore) return [];
    return this.rootstore?.generalMode === AnalyticsV2ElementType.Report
      ? this.genstore.ReportsList
      : this.genstore.UnifiedList;
  }

  // debounced updating in order to take only last model version.
  // for instance, when the user is mutating the model parameters too often
  debouncedGraphUpdate: Function | undefined = undefined; // charts settings update function
  debouncedFormulasUpdate: Function | undefined = undefined; // table formulas update function
  debouncedPinStatus: Function | undefined = undefined; // table items selection update function

  // read/write/workload access
  RA: boolean = false;
  WA: boolean = false;
  WLoadA: boolean = false;
  StorageRA: boolean = false;
  StorageWA: boolean = false;

  // renew query after mounted
  // used to setup if the analytics table should be loaded on start
  shouldRenew = false;
  // if true then cannot update
  filtersIncorrect = false;
  chartsIncorrect = false;

  get filtersValidationMutated() {
    return _.cloneDeep(this.setstore?.getFilterValidation);
  }
  get chartsValidationMutated() {
    return _.cloneDeep(this.graphstore?.getChartsValidation);
  }

  @Watch("filter_string")
  onFilterStringChanged(val: string) {
    if (!this.genstore) return;
    this.genstore.applyAnalyticsSearchFilter(val || "");
  }

  // component initialization
  created() {
    this.splitterModel = reactive({
      inner: this.user_inner_splitter,
      outer: this.user_outer_splitter,
    });

    this.debouncedPinStatus = useDebounceFn(async (that: any) => {
      // update selection on the server
      const multistore = multiEditStore();
      await multistore.changePinStatus({
        Container: {
          EntityIds:
            that.selectedAll !== "none"
              ? that.unselectedEntities || []
              : that.selectedEntities || [],
          TakeAnything: that.selectedAll !== "none",
          Segment: (that.genstore.selectedItem as BaseListItem).DestType,
          ElementIdentity: {
            ElementId: (that.genstore.selectedItem as BaseListItem).Id,
            Source: [0, 1, 2, 3, 4, 5, 6, 7, 8].includes(
              (that.genstore.selectedItem as BaseListItem).SrcType
            )
              ? (that.genstore.selectedItem as BaseListItem).SrcType
              : null,
            Destination: (that.genstore.selectedItem as BaseListItem).DestType,
            Kind: getIdentityKind(that.genstore.selectedItem as BaseListItem),
          } as AnalyticsElementIdentity,
        },
      } as PinnedEntitiesSetRequest);
    }, 100);

    const route = useRoute();
    this.router = useRouter();
    const id = route.query.token || "";
    const old_skey = route.query.skey || "";
    const old_uid = route.query.uid || "";

    // Язык берём из профиля пользователя.
    // ?lang= в URL — явное переопределение и уважается, только если локаль реально есть:
    // иначе i18n получал бы мусор и сваливался в fallback (en), затирая язык профиля.
    const langParam = route.query.lang ? String(route.query.lang) : "";
    this.hasExplicitLang = SUPPORTED_LOCALES.includes(langParam);

    this.selectedEntities = reactive([]);
    this.unselectedEntities = reactive([]);

    if (this.hasExplicitLang) {
      this.$i18n.locale = langParam;
      // @ts-ignore
      i18n.global.locale = langParam;
    }

    this.rootstore = rootStore();

    let allowed_segments = [0, 1, 2, 3, 4, 5, 6, 7, 8, 900];

    // if get params from the url not empty focus corresponding item in the left panel
    if (
      route.query.dest !== "" &&
      route.query.dest !== this.rootstore.generalMode &&
      allowed_segments.includes(parseInt("" + route.query.dest))
    ) {
      // if the destination segment is correct
      this.rootstore.setGeneralMode(parseInt("" + route.query.dest));
    } else {
      if (route.query.prioritydest !== "" && [0,1,2,3,4,5,6,7,8].includes(parseInt("" + route.query.prioritydest))) {
        this.rootstore.setGeneralMode(parseInt("" + route.query.prioritydest));
      } else {
        // if the destination is not correct set projects (0);
        this.rootstore.setGeneralMode(0);
      }
    }

    this.genstore = generalStore();
    this.genstore.initFavoriteModeFromStorage();
    this.setstore = settingsStore();
    this.graphstore = graphSettingsStore();
    this.querystore = queryStore();
    this.auxstore = auxStore();
    this.storage = storageStore();
    this.storage_pos = storagePositionsStore();

    // if get params
    if (
      route.query.id !== "" &&
      route.query.type !== "" &&
      route.query.dest !== ""
    ) {
      const selectedType = route.query.type
        ? parseInt("" + route.query.type)
        : undefined;
      const selectedId = route.query.id ? parseInt("" + route.query.id) : undefined;
      const selectedDest = route.query.dest
        ? parseInt("" + route.query.dest)
        : undefined;
      const linkIdentity =
        selectedType === BaseItemTypes.FOLDER
          ? ({
            FolderId: selectedId,
            elType: selectedType,
            DestType: selectedDest,
          } as BaseListItem)
          : ({
            Id: selectedId,
            elType: selectedType,
            SrcType: route.query.src ? parseInt("" + route.query.src) : undefined,
            DestType: selectedDest,
          } as BaseListItem);
      this.genstore.setSelectedAfter(linkIdentity, true);
      // Одноразовая подсветка элемента, на который перешли по ссылке.
      this.genstore.setLinkHighlight(linkIdentity);
      this.shouldRenew = true;
    }

    // type=900 — это режим отчётов. Переключаем сегмент в REPORTS,
    // и (если есть id) выбираем конкретный отчёт после загрузки.
    const tParam = parseInt("" + (route.query.type ?? ""));
    if (tParam === BaseItemTypes.REPORT) {
      this.rootstore.setGeneralMode(AnalyticsV2ElementType.Report);
      if (route.query.id) {
        const reportLinkIdentity = {
          Id: parseInt("" + route.query.id),
          elType: BaseItemTypes.REPORT,
        } as BaseListItem;
        this.genstore.setSelectedAfter(reportLinkIdentity, true);
        this.genstore.setLinkHighlight(reportLinkIdentity);
        this.shouldRenew = true;
      }
    }

    this.resetPagination();
    // this.auxstore = storeToRefs(this.auxstore);

    this.compound_ids = reactive([]);
    this.groupMode = false;

    if (this.rootstore) {
      if (id) {
        this.rootstore.setJWT(id.toString(), old_skey.toString(), old_uid.toString());
      }
      this.auxstore.initContainers();

      this.storage_pos.initData();
      this.storage.initData();
    }

    // store to refs in order to pass them to v-model: props
    // this.graphstore = storeToRefs(this.graphstore);
    // this.setstore = storeToRefs(this.setstore);
    // this.querystore = storeToRefs(this.querystore);
  }

  async mounted() {
    document.addEventListener('mousedown', this.onPlusDocumentMousedown, true);
    document.addEventListener('keydown', this.onGlobalEscCapture, true);
    await this.genstore.checkGeneralAccess();
    await this.storage.getStorageAccess();

    const wstore = workerStore();
    if (!wstore.workerProfile) {
      await wstore.getWorkerProfile(!this.hasExplicitLang);
    }

    this.RA = this.genstore.accessRights.GeneralAccess;
    this.WA = this.genstore.accessRights.WriteAccess;
    this.WLoadA = this.genstore.accessRights.AccessToWorkload;

    this.StorageRA = this.storage.storageAccess?.CanRead;
    this.StorageWA = this.storage.storageAccess?.CanWrite;

    if (this.RA) {
      return;
    }

    this.changeMode(this.rootstore.generalMode);
  }

  beforeUnmount() {
    document.removeEventListener('mousedown', this.onPlusDocumentMousedown, true);
    document.removeEventListener('keydown', this.onGlobalEscCapture, true);
    // Класс на корне документа обязательно снимаем, иначе после ухода со страницы
    // таблицы окно останется без прокрутки.
    document.documentElement.classList.remove('analytics-window-clip');
  }

  // Полосу прокрутки рисует корневой элемент документа (html), scoped-стили компонента
  // до него не достают. Пока показана таблица, вешаем на html класс, который прячет
  // прокрутку окна: незначительное кадровое превышение высоты (min-height Quasar) не
  // должно порождать глобальный скролл. На графиках/пустой странице класс снимается.
  @Watch("clipPageScroll", { immediate: true })
  onClipPageScrollChange(clip: boolean) {
    document.documentElement.classList.toggle('analytics-window-clip', !!clip);
  }

  get containerForNewMovement(): MultiEditEntityContainer | undefined {
    return this.selectedCount > 0 && (this.genstore.selectedItem as BaseListItem).DestType === 7 ? {
      EntityIds:
        this.selectedAll !== "none"
          ? this.unselectedEntities || []
          : this.selectedEntities || [],
      TakeAnything: this.selectedAll !== "none",
      Segment: (this.genstore.selectedItem as BaseListItem).DestType,
      ElementIdentity: {
        ElementId: (this.genstore.selectedItem as BaseListItem).Id,
        Source: [0, 1, 2, 3, 4, 5, 6, 7, 8].includes(
          (this.genstore.selectedItem as BaseListItem).SrcType
        )
          ? (this.genstore.selectedItem as BaseListItem).SrcType
          : null,
        Destination: (this.genstore.selectedItem as BaseListItem).DestType,
        Kind: getIdentityKind(this.genstore.selectedItem as BaseListItem),
      } as AnalyticsElementIdentity,
    } : undefined;
  }

  get selectedCount(): number {
    return this.selectedAll === "none"
            ? this.selectedEntities.length
            : Number(this.pagination.total_count) - Number(this.unselectedEntities.length)
  }

  // current filters validation watcher
  // val - array of found errors
  @Watch("filtersValidationMutated", { deep: true })
  updateIncorrect(val: any) {
    this.filtersIncorrect = val.length > 0;
  }

  // current chart options validation watcher
  // val - array of found errors
  @Watch("chartsValidationMutated", { deep: true })
  updateChartsIncorrect(val: any) {
    this.chartsIncorrect = val.length > 0;
  }

  // TEMPORARY TO DEBUG
  // save(payload: any) {
  // console.log("submit", payload);
  // }

  // left panel expand top button
  setUpperExpand(val: boolean) {
    this.upperExpand = val;
    if (val) {
      if (this.splitterModel.inner > 0 && this.splitterModel.inner < 100) {
        this.previousSplit = this.splitterModel.inner;
      }

      this.splitterModel.inner = 100;
      this.bottomExpand = !val;
    } else {
      if (!this.bottomExpand) {
        this.splitterModel.inner =
          this.previousSplit > -1
            ? this.previousSplit
            : this.user_inner_splitter;
      }
    }
  }

  // left panel expand bottom button
  setBottomExpand(val: boolean) {
    this.bottomExpand = val;
    if (val) {
      if (this.splitterModel.inner > 0 && this.splitterModel.inner < 100) {
        this.previousSplit = this.splitterModel.inner;
      }

      this.splitterModel.inner = 0;
      this.upperExpand = !val;
    } else {
      if (!this.upperExpand) {
        this.splitterModel.inner =
          this.previousSplit > -1
            ? this.previousSplit
            : this.user_inner_splitter;
      }
    }
  }

  // expand or collapse if the user drags splitter by hand
  // if the height is less than some value left
  @Watch("splitterModel.inner")
  inner_watcher(arg: number) {
    if (arg > 0 && arg < 85) {
      this.upperExpand = false;
      this.bottomExpand = false;
    }

    if (arg !== default_inner_splitter) {
      localStorage.innersplit = arg;
    }
  }

  @Watch("splitterModel.outer")
  outer_watcher(arg: number) {
    if (arg !== default_outer_splitter) {
      localStorage.outersplit = arg;
    }
  }

  // download table xls
  saveTableToFile(arg: any, name: string) {
    if (this.auxstore) {
      this.auxstore.downloadTableFile(arg, name);
    }
  }

  // set search input focused
  focusSearch() {
    const that = this;
    this.$nextTick(() => {
      //@ts-ignore
      that.$refs.panel_search_input.focus();
      that.filter_string = "";
    });
  }

  onUpdatePagination(arg: any) {
    this.pagination = arg;
  }

  onSelectionUpdate(val: any[]) {
    console.log("updated selectedEntities", val);
    this.selectedEntities = reactive(val);
  }

  onUnSelectionUpdate(val: any) {
    this.unselectedEntities = reactive(val);
  }

  onSelectedAllUpdate(val: any) {
    this.selectedAll = reactive(val);
  }

  updatePinned() {
    this.debouncedPinStatus && this.debouncedPinStatus(this);
  }

  addToGroup(val: string[]) {
    this.compound_ids = reactive(val);
  }

  onCancelGroupClick() {
    const that = this;
    setTimeout(() => {
      that.compound_ids.splice(0);
      that.groupMode = false;
    }, 100);
  }

  async onGroupClick() {
    if (this.groupMode) {
      // alert(JSON.stringify(this.compound_ids))
      this.setstore.groupColumns(this.compound_ids /*, 1*/);
      const that = this;
      setTimeout(() => {
        that.compound_ids.splice(0);
        that.groupMode = false;
      }, 100);
    } else {
      this.compound_ids.splice(0);
      this.groupMode = true;
    }
  }

  onUnGroupClick(arg: number) {
    this.compound_ids.splice(0);
    this.setstore.groupColumns(this.compound_ids, arg);
  }

  onUnGroupSingleClick(arg: any) {
    this.compound_ids.splice(0);
    // console.log('single ungroup')
    // console.log(arg.group_id+' '+arg.compound_id)
    this.setstore.groupColumns(
      this.compound_ids,
      arg.group_id,
      arg.compound_id
    );
  }

  // removeFromGroup(val: string) {
  //   this.compound_ids.push(val)
  // }

  // cloned objects, otherwise the val and oldval in any @Watch will be the same new val object
  get graphSettingsMutated() {
    return _.cloneDeep(this.graphstore?.selectedSettings);
  }
  get filterSettingsMutated() {
    return _.cloneDeep(this.setstore?.getCurrentFilters);
  }
  get tableFormulasMutated() {
    return _.cloneDeep(this.setstore?.getTableFormulas);
  }
  get pfilterSettingsMutated() {
    return _.cloneDeep(this.setstore?.getProjectionFilters);
  }
  get elementOptionsMutated() {
    return _.cloneDeep(this.setstore?.getProjectionOptions);
  }

  @Watch("graphSettingsMutated", { deep: true })
  updateGModel(val: any, oldval: any) {
    if (this.graphstore.isMutating) {
      this.$nextTick(() => {
        this.graphstore.setMutating(false);
      });
      return;
    }

    const item = _.cloneDeep(this.genstore.selectedItem);
    if (_.isEqual(val, oldval)) {
      return;
    }
    if (
      (val && item.elType === BaseItemTypes.BAR_CHART) ||
      item.elType === BaseItemTypes.PIE_CHART ||
      item.elType === BaseItemTypes.GRAPH
    ) {
      const request: AnalyticsChartIdentity = {
        ChartId: item.Id,
        ChartType:
          item.elType === 2
            ? AnalyticsV2ChartType.Linear
            : item.elType === 3
            ? AnalyticsV2ChartType.Pie
            : AnalyticsV2ChartType.Bar,
        Destination: item.DestType,
      };

      // there is no situation when we need to update main settings ang
      // chart elements settings at the same time; so:

      // update main settings by default;
      let el_i = -1;
      // check if some element is changed then update it; otherwise update main model;
      const sector_name =
        item.elType === BaseItemTypes.GRAPH
          ? "Curves"
          : item.elType === BaseItemTypes.BAR_CHART
          ? "BarCharts"
          : "PieCharts";
      // В некоторых промежуточных состояниях watcher может получить модель без Curves/BarCharts/PieCharts.
      // Не допускаем падения по undefined и продолжаем обновление только при валидном массиве.
      const el_arr = Array.isArray(val?.[sector_name]) ? val[sector_name] : [];
      const old_el_arr = Array.isArray(oldval?.[sector_name]) ? oldval[sector_name] : [];

      if (!Array.isArray(val?.[sector_name])) {
        console.log("update fail");
        console.log(val);
      } else {
        // Also indicate errors on dependant fields if they are not filled, for instance
        this.graphstore.validateCharts(val, item.elType, sector_name);
      }

      const max_len = Math.max(el_arr.length, old_el_arr.length);
      for (let sector = 0; sector < max_len; sector++) {
        if (!_.isEqual(el_arr[sector], old_el_arr[sector])) {
          el_i = sector;
          break;
        }
      }
      this.graphstore.updateSettings(request, el_i);
    }
  }

  @Watch("filterSettingsMutated", { deep: true })
  updateFiltersModel(val: any, oldval: any) {
    // console.log("filters mut");
    // console.log(val);

    if (this.setstore.isMutating) {
      this.$nextTick(() => {
        this.setstore.setMutating(false);
      });
      return;
    }

    for (let filt = 0; filt < val.length; filt++) {
      if (!oldval || !oldval[filt]) {
        return;
      }

      if (!_.isEqual(val[filt], oldval[filt])) {
        console.log("filters differ");

        // Also indicate errors on dependant fields if they are not filled, for instance
        this.setstore.validateFilters(val[filt]);
        // validation errors are stored in the store if any
        let item = undefined;
        // console.log('log:')
        // console.log(this.genstore.selectedItem)
        if (
          this.genstore.selectedItem &&
          [BaseItemTypes.SELECTION, BaseItemTypes.LIST].includes(
            this.genstore.selectedItem.elType
          )
        ) {
          item = this.genstore.selectedItem;
        } else {
          const chain = this.setstore.getProjectionParentChain;

          if (chain && chain.length) {
            item = {
              Id: chain[0].Identity.ElementId,
              //chain[0].elType =
              elType:
                chain[0].Source !== undefined && chain[0].Source !== null
                  ? BaseItemTypes.PROJECTION
                  : chain[0].Identity.Kind === 0
                  ? BaseItemTypes.SELECTION
                  : BaseItemTypes.LIST,
              SrcType: chain[0].Identity.Source,
              DestType: chain[0].Identity.Destination,
            };
          }
        }
        if (item) {
          console.log("update filters");
          this.setstore.updateFilterSettings(
            _.cloneDeep(item),
            val[filt],
            true
          );
        }
      }
    }
  }

  @Watch("pfilterSettingsMutated", { deep: true })
  updatePFiltersModel(val: any, oldval: any) {
    if (this.setstore.isMutating) {
      this.$nextTick(() => {
        this.setstore.setMutating(false);
      });
      return;
    }

    for (let filt = 0; filt < val.length; filt++) {
      if (!oldval || !oldval[filt]) {
        return;
      }
      if (
        this.setstore &&
        this.genstore &&
        val[filt] &&
        !_.isEqual(val[filt], oldval[filt])
      ) {
        // validation errors are stored in the store if any
        this.setstore.updateFilterSettings(
          _.cloneDeep(this.genstore.selectedItem),
          val[filt],
          true
        );
      }
    }
  }

  @Watch("tableFormulasMutated", { deep: true })
  updateTFModel(val: any, oldval: any) {
    if ([7,8].includes(this.genstore.selectedItem.DestType)) { return }

    if (this.setstore.isMutating) {
      this.$nextTick(() => {
        this.setstore.setMutating(false);
      });
      return;
    }

    if (
      this.genstore &&
      val &&
      this.genstore.selectedItem?.Id &&
      !_.isEqual(val, oldval)
    ) {
      this.setstore.validateFormulas(val);
      this.setstore.updateTableFormulas(
        {
          element: this.genstore.selectedItem,
          Formulas: val,
        },
        true
      );
    }
  }

  @Watch("elementOptionsMutated", { deep: true })
  updateOptsModel(val: any, oldval: any) {
    if (this.setstore.isMutating) {
      this.$nextTick(() => {
        this.setstore.setMutating(false);
      });
      return;
    }

    if (
      this.genstore &&
      val &&
      val.length &&
      this.genstore.selectedItem?.Id &&
      !_.isEqual(val, oldval)
    ) {
      this.setstore.updateElementOptions(
        {
          element: this.genstore.selectedItem,
          Options: val,
        },
        true
      );
    }
  }

  async onRefreshTable(pag: any) {
    const that = this;
    setTimeout(async () => {
      that.selectedEntities = [];
      that.selectedAll = "none";
      that.unselectedEntities = [];

      const old_offset = pag.offset;

      that.pagination.recalculate = true;
      that.pagination.forceInitial = false;
      that.pagination.offset = 0;
      that.pagination.sortMode = pag.sortMode;
      that.pagination.sortCategory = pag.sortCategory;
      that.pagination.OrderByPinned = pag.OrderByPinned;
      console.log("1 request");
      await that.querystore.getResultTable(
        that.genstore.selectedItem,
        that.pagination,
        false
      );
      that.pagination.total_count = +that.querystore.getCurrentTable?.Count;
      that.pagination.OrderByPinned = that.querystore.getCurrentTable?.PinnedOptions?.OrderByPinned ?? false;

      const pinned = this.querystore.getCurrentTable?.PinnedOptions
      if (pinned) {
        this.selectedEntities = pinned.TakeAll
          ? []
          : pinned.PinnedEntities || [];
        this.selectedAll = !pinned.TakeAll
          ? "none"
          : pinned.PinnedEntities?.length
          ? "many"
          : "all";
        this.unselectedEntities = pinned.TakeAll
          ? pinned.PinnedEntities || []
          : [];
      }

      if (old_offset > 0) {
        console.log("2 request");
        // and then to old page
        that.pagination.offset = old_offset;
        that.pagination.recalculate = false;
        that.pagination.forceInitial = false;
        await that.querystore.getResultTable(
          that.genstore.selectedItem,
          that.pagination,
          false
        );
      }
      // recalc — одноразовый серверный флаг: сбрасываем безусловно, в т.ч. для
      // ветки offset===0, где второй запрос не выполнялся и recalc оставался true.
      that.pagination.recalculate = false;
    }, 300);
  }

  get user_inner_splitter() {
    return +localStorage.innersplit > 0
      ? +localStorage.innersplit
      : default_inner_splitter;
  }

  get user_outer_splitter() {
    const saved = +localStorage.outersplit;
    if (saved > 0) {
      // Migrate old default width to the new default.
      return saved === 400 ? default_outer_splitter : saved;
    }
    return default_outer_splitter;
  }

  reloadNameContainer() {
    // В режиме отчёта name-container не используется — пропускаем перезапрос полностью.
    // Сам отчёт, любой Break, и любой ребёнок отчёта не должны триггерить запрос.
    const sel = this.genstore.selectedItem;
    const parent = this.genstore.selectedItemParent;
    if (sel?.elType === BaseItemTypes.REPORT
        || sel?.elType === BaseItemTypes.BREAK
        || parent?.elType === BaseItemTypes.REPORT) {
      return;
    }
    if (![0, 1].includes(this.genstore.selectedItem.elType)) {
      this.storage_pos.reloadNameContainer({} as AnalyticsElementIdentity)
      return
    }

    this.storage_pos.reloadNameContainer({
      ElementId: (this.genstore.selectedItem as BaseListItem).Id,
      Source: [0, 1, 2, 3, 4, 5, 6, 7, 8].includes(
        (this.genstore.selectedItem as BaseListItem).SrcType
      )
        ? (this.genstore.selectedItem as BaseListItem).SrcType
        : null,
      Destination: (this.genstore.selectedItem as BaseListItem).DestType,
      Kind: getIdentityKind(this.genstore.selectedItem as BaseListItem),
    } as AnalyticsElementIdentity)
  }

  @Watch("genstore.selectedItem")
  async selected_watcher(current: BaseListItem, old: BaseListItem) {
    this.resetPagination();

    // Признак того, что по итогам этой смены реально стартует запрос таблицы. Если
    // запроса не будет (папка, отчёт, элемент без Id, тот же элемент), общий спиннер
    // держать нельзя — он висел бы зря и сбивал с толку (например, после смены сегмента).
    let willLoad = false;

    // Фактическая смена элемента: идентичность реально изменилась, а не просто
    // пришла новая ссылка на тот же элемент.
    const elementChanged =
      !old ||
      current.elType !== old.elType ||
      current.Id !== old.Id ||
      current.FolderId !== old.FolderId ||
      current.SrcType !== old.SrcType ||
      current.DestType !== old.DestType ||
      current.ElementId !== old.ElementId;

    if (elementChanged) {
      // Смена элемента: сразу очищаем таблицу и показываем общий спиннер.
      // clearTable обязателен — он размонтирует таблицу (v-if), и новый элемент с
      // другой структурой столбцов отрисуется свежим маунтом, а не in-place rebuild
      // (иначе бывает пустая/белая сетка). switchingElement держит общий спиннер до
      // прихода данных нового элемента. Старый запрос отменяется ниже (abortAllPending).
      this.querystore.clearTable();
      this.switchingElement = true;
    }

    if (current.elType === BaseItemTypes.REPORT) {
      this.splitterModel.inner = 85;
    } else if (this.splitterModel.inner > 80) {
      this.splitterModel.inner = this.user_inner_splitter;
    }

    this.reloadNameContainer();

    if (current.elType === BaseItemTypes.FOLDER) {
      this.querystore.abortAllPending();
      this.auxstore.abortAllPending();
      this.querystore.clearSettings();
      // у папки своей таблицы нет — спиннер смены гасим сразу
      this.switchingElement = false;
      if (current.FolderId) {
        this.syncSelectionToUrl(current);
      }
    } else if (current.Id) {
      this.syncSelectionToUrl(current);

      if (current.elType !== 900) {
        if (
          !current ||
          !old ||
          current.Id !== old.Id ||
          (old.SrcType ? current.SrcType !== old.SrcType : current.SrcType) ||
          current.DestType !== old.DestType ||
          current.elType !== old.elType ||
          ((current.ElementId || old.ElementId) &&
            current.ElementId !== old.ElementId)
        ) {
          this.querystore.abortAllPending();
          this.auxstore.abortAllPending();

          const res = await this.auxstore.entityHasSavedState(current);

          // recalc для первого initial зависит от ответа сервера: есть сохранённое
          // состояние -> грузим из кэша (recalc=false), нет -> форс-пересчёт (recalc=true).
          // Грузим всегда; спиннер смены снимется по query_loading_watcher.
          const hasSaved =
            !!(res && res.data && res.data.Result) || current.elType === 6;
          const that = this;
          willLoad = true;
          setTimeout(() => {
            that.getQueryResult(!hasSaved);
          }, 100);
        } else {
          console.log("selected watcher - same, not updating");
          // тот же элемент, перезапроса не будет — на всякий случай гасим флаг смены
          this.switchingElement = false;
        }
      }
    }

    // Ни одна ветка не стартовала запрос таблицы — снимаем спиннер смены, иначе он
    // останется висеть (нет querystore.isLoading, который бы его погасил).
    if (!willLoad) this.switchingElement = false;
  }

  /**
   * Отражаем выбранный элемент в адресной строке и в заголовке вкладки. Формат query
   * совпадает с тем, что читается при загрузке в created (type/src/dest/id), поэтому ссылку
   * можно скопировать и по ней элемент выберется снова. Для папки id = FolderId и src
   * пустой (FolderIdentity); для остальных - полная Identity. replace, а не push: строка отражает
   * текущий выбор, но не копит историю (кнопка "Назад" не перебирает элементы).
   */
  syncSelectionToUrl(current: BaseListItem) {
    const isFolder = current.elType === BaseItemTypes.FOLDER;
    const id = isFolder ? current.FolderId : current.Id;
    if (!this.router || !id) return;

    const currentQuery = this.router.currentRoute?.value?.query || {};
    const query = {
      ...currentQuery,
      type: String(current.elType),
      src:
        isFolder || current.SrcType === undefined || current.SrcType === null
          ? ""
          : String(current.SrcType),
      dest: String(current.DestType),
      id: String(id),
    };
    // Дубликат-навигация (тот же URL) отклоняется промисом - гасим, это не ошибка.
    this.router.replace({ query }).catch(() => {});

    const name = current.CombinedName || current.Name || "";
    document.title = name ? "Аналитика | " + name : "Аналитика";
  }

  // Как только загрузка завершилась, снимаем флаг смены элемента: дальше таблицу
  // (или пустую подпись) показывает уже обычная логика по наличию данных.
  @Watch("querystore.isLoading")
  query_loading_watcher(val: boolean) {
    if (!val) this.switchingElement = false;
  }

  @Watch("genstore.isLoading", { deep: true })
  renew_watcher(val: boolean, old_val: boolean) {
    if (!val && old_val && this.shouldRenew) {
      // console.log("renew");
      this.shouldRenew = false;
      // const that = this
      // setTimeout(() => {
      //   that.getQueryResult();
      // }, 100);
    }
  }

  @Watch("createListDialog", { deep: true })
  list_dialog_watcher(val: boolean) {
    if (!val) {
      this.tempListBase = undefined;
    }
  }

  get drawerWidth() {
    return this.splitterModel.outer + 1;
  }

  get splitterClass() {
    return !this.leftDrawerOpen ? "splitt" : "";
  }

  get compPadding() {
    return this.leftDrawerOpen ? { paddingLeft: "0px" } : "";
  }

  onChange(v: any) {
    this.leftDrawerOpen = v > splitter_close_threshold;
  }

  private isSelectionModeActive(): boolean {
    const virtualList = this.$refs.virtualListRef as any;
    const selectionModeRaw = virtualList?.selectionMode;
    return !!(
      selectionModeRaw &&
      (typeof selectionModeRaw === "object" && "value" in selectionModeRaw
        ? selectionModeRaw.value
        : selectionModeRaw)
    );
  }

  onGlobalEscCapture(event: KeyboardEvent) {
    if (event.key !== "Escape") return;
    if (!this.isSelectionModeActive()) return;
    const virtualList = this.$refs.virtualListRef as any;
    virtualList?.exitSelectionMode?.();
    event.preventDefault();
    event.stopPropagation();
    (event as any).stopImmediatePropagation?.();
  }

  onEscKeydown() {
    if (this.isSelectionModeActive()) {
      const virtualList = this.$refs.virtualListRef as any;
      virtualList?.exitSelectionMode?.();
      return;
    }
    if (this.bottomExpand) {
      this.setBottomExpand(false);
    } else if (this.upperExpand) {
      this.setUpperExpand(false);
    }
    this.groupMode = false;
    this.compound_ids.splice(0);
    this.genstore.setGlobalFilterMode(false);
    this.filter_string = "";
  }

  @Watch("genstore.favoriteMode")
  onFavoriteModeChanged(enabled: boolean, wasEnabled: boolean) {
    if (!enabled || wasEnabled || !this.genstore) return;
    const selected = this.genstore.selectedItem as any;
    if (!selected || selected.elType == null) return;
    if (selected.IsFavorite !== true) {
      this.genstore.clearCurrentSelection();
    }
  }

  @Watch("tab")
  tab_watcher() {
    this.groupMode = false;
    this.compound_ids.splice(0);
  }

  resetPagination() {
    this.old_arg = undefined;
    this.pagination = reactive({
      count: Number(this.auxstore.getTableRowCount),
      offset: 0,
      recalculate: false,
      forceInitial: true,
      sortMode: 0,
      OrderByPinned: false,
      report: false,
      total_count: 0,
      report_index: -1,
    } as PaginationProps);

    // reset selection
    this.selectedEntities = [];
    this.selectedAll = "none";
    this.unselectedEntities = [];
    this.tempListBase = undefined;
  }

  changeMode(arg: AnalyticsV2ElementType) {
    this.rootstore && this.rootstore.setGeneralMode(arg);
    if (this.genstore) {
      this.resetPagination();

      this.setstore.clearSettings();
      this.genstore.clearGeneralList();
      this.genstore.getGeneralAnalyticsData(arg);
    }
  }

  // open dialog for selecting reports
  openAddToReport(arg: BaseListItem) {
    this.reportIdsModel = [];

    this.itemToReport = arg;
    const that = this;
    setTimeout(async () => {
      that.reportOptions = [
        ...((await that.auxstore.getReportsList()).data as CommonEntity[]),
        { Id: 0, Name: this.$t("create_report_and_add") },
      ];
    }, 10);

    // console.log("open report ids");
    this.addToReportDialog = true;
  }

  // open dialog for creating a new list
  async openCreateList(params: any) {
    this.tempListBase = params;

    await this.genstore.precalcCurrentItem({
      Destination: this.tempListBase.hoverParams.destinationDataType,
      ElementId: this.tempListBase.hoverParams.id,
      Kind:
        this.tempListBase.hoverParams.elType === BaseItemTypes.SELECTION
          ? AnalyticsElementKind.Selection
          : this.tempListBase.hoverParams.elType === BaseItemTypes.PROJECTION
          ? AnalyticsElementKind.Projection
          : AnalyticsElementKind.List,
      Source:
        this.tempListBase.hoverParams.elType &&
        [BaseItemTypes.SELECTION, BaseItemTypes.LIST].includes(
          this.tempListBase.hoverParams.elType
        )
          ? null
          : this.tempListBase.hoverParams.sourceDataType,
    } as AnalyticsElementIdentity);

    this.createListDialog = true;
  }

  drawerButtonClick() {
    this.leftDrawerOpen = !this.leftDrawerOpen;
    this.splitterModel.outer = this.user_outer_splitter;
  }

  onItemSelected(arg: any) {
    if (this.genstore) {
      if (arg?.clearSelection) {
        this.genstore.clearCurrentSelection();
        return;
      }
      if (this.old_arg !== this.genstore.selectedItem) {
        this.resetPagination();
      }
      // renew table
      // const that = this
      // setTimeout(() => {
      //   that.getQueryResult();
      // }, 100);

      if (arg.switch) {
        this.genstore.setSelectedAfter(arg.element, arg.scrollto);
        this.changeMode(arg.segment);
      } else {
        this.genstore.setSelectedAfter(arg.element, false);
        this.genstore.applyElementAction(arg.element, "select", true, false, "user");
      }
    }
  }

  private setPlusMenuPosition(ev: MouseEvent) {
    const anchor = ev.currentTarget as HTMLElement;
    const rect = anchor.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
    const menuHeight = this.canShowPlusChartItems ? 240 : 120;
    const menuWidth = 180;
    const margin = 8;
    let top = rect.bottom;
    if (rect.bottom + menuHeight > viewportHeight - margin) {
      top = rect.top - menuHeight;
      if (top < margin) top = margin;
    }
    let left = rect.left;
    if (left + menuWidth > viewportWidth - margin) {
      left = Math.max(margin, viewportWidth - menuWidth - margin);
    }
    this.plusMenuPos.top = `${top}px`;
    this.plusMenuPos.left = `${left}px`;
  }

  private clearPlusMenuCloseTimer() {
    if (this.plusMenuCloseTimer) {
      clearTimeout(this.plusMenuCloseTimer);
      this.plusMenuCloseTimer = null;
    }
  }

  // Даём короткий люфт для перевода курсора между кнопкой "+" и меню без случайного закрытия.
  private schedulePlusMenuClose() {
    this.clearPlusMenuCloseTimer();
    this.plusMenuCloseTimer = setTimeout(() => {
      this.plusMenuOpen = false;
      this.plusMenuCloseTimer = null;
    }, 220);
  }

  openPlusMenu(ev: MouseEvent) {
    this.clearPlusMenuCloseTimer();
    this.setPlusMenuPosition(ev);
    this.plusMenuOpen = true;
  }

  onPlusButtonLeave() {
    this.schedulePlusMenuClose();
  }

  onPlusMenuEnter() {
    this.clearPlusMenuCloseTimer();
  }

  onPlusMenuLeave() {
    this.schedulePlusMenuClose();
  }

  onPlusDocumentMousedown(ev: MouseEvent) {
    if (!this.plusMenuOpen) return;
    const target = ev.target as HTMLElement | null;
    if (!target) return;
    const anchor = this.$refs.plus_menu_anchor as HTMLElement | undefined;
    if (anchor && anchor.contains(target)) return;
    if (typeof target.closest === 'function' && target.closest('.plus-context-menu')) return;
    this.clearPlusMenuCloseTimer();
    this.plusMenuOpen = false;
  }

  togglePlusMenu(ev: MouseEvent) {
    this.clearPlusMenuCloseTimer();
    this.setPlusMenuPosition(ev);
    this.plusMenuOpen = !this.plusMenuOpen;
  }

  onPlusMenuCreateFolder() {
    this.plusMenuOpen = false;
    this.plusCreateFolder();
  }

  onPlusMenuCreateSelection() {
    this.plusMenuOpen = false;
    this.plusCreateSelection();
  }

  onPlusMenuCreateChart(chartType: BaseItemTypes.GRAPH | BaseItemTypes.PIE_CHART | BaseItemTypes.BAR_CHART) {
    const sel = this.genstore?.selectedItem;
    if (!sel) return;

    this.plusMenuOpen = false;
    this.addChildChart({
      hoverParams: {
        id: sel.Id,
        folderId: sel.FolderId,
        isRoot: sel.isRoot,
        elType: sel.elType,
        isEditing: sel.isEditing,
        isExpanded: sel.isExpanded,
        sourceDataType: sel.SrcType,
        destinationDataType: sel.DestType,
        innerElementId: sel.ElementId,
        CombinedName: sel.CombinedName,
        chartType,
      },
    });
  }

  get canShowPlusChartItems() {
    const sel = this.genstore?.selectedItem;
    if (!sel) return false;
    if (sel.DestType === 5) return false;

    const elType = sel.elType as BaseItemTypes;
    const parent = this.genstore?.selectedItemParent;
    const isLiteralRoot = !parent || parent.elType === undefined || parent.elType === null;
    const isRootSelectionByMeaning =
      elType === BaseItemTypes.SELECTION &&
      (isLiteralRoot || parent?.elType === BaseItemTypes.FOLDER);

    return (
      (isLiteralRoot &&
        [BaseItemTypes.SELECTION, BaseItemTypes.PROJECTION, BaseItemTypes.LIST].includes(elType)) ||
      isRootSelectionByMeaning ||
      elType === BaseItemTypes.FOLDER
    );
  }

  onItemFavorite(arg: BaseListItem) {
    if (this.genstore) {
      if (this.old_arg !== this.genstore.selectedItem) {
        this.resetPagination();
      }
      this.genstore.applyElementAction(arg, "favorite");
    }
  }

  onItemRenamed(arg: any) {
    if (this.genstore) {
      this.genstore.applyElementAction(arg, "rename");
    }
  }

  onBreakAfter(arg: any) {
    if (this.genstore) {
      this.genstore.addReportBreak({
        id: arg.Id,
        newPosition: arg.newpos,
      });
    }
  }

  /** Склоняет «элемент» по числу с учётом текущей локали (ru: 1 элемент / 2 элемента / 5 элементов). */
  private pluralizeElements(n: number): string {
    const locale = (this.$i18n?.locale ?? 'ru') as string;
    if (locale === 'ru') {
      const mod10 = n % 10;
      const mod100 = n % 100;
      if (mod100 >= 11 && mod100 <= 19) return String(this.$t('confirm_elements_many'));
      if (mod10 === 1) return String(this.$t('confirm_elements_one'));
      if (mod10 >= 2 && mod10 <= 4) return String(this.$t('confirm_elements_few'));
      return String(this.$t('confirm_elements_many'));
    }
    return n === 1
      ? String(this.$t('confirm_elements_one'))
      : String(this.$t('confirm_elements_many'));
  }

  /** Склоняет «вложенный элемент» по числу с учётом текущей локали. */
  private pluralizeNested(n: number): string {
    const locale = (this.$i18n?.locale ?? 'ru') as string;
    if (locale === 'ru') {
      const mod10 = n % 10;
      const mod100 = n % 100;
      if (mod100 >= 11 && mod100 <= 19) return String(this.$t('confirm_nested_elements_many'));
      if (mod10 === 1) return String(this.$t('confirm_nested_elements_one'));
      if (mod10 >= 2 && mod10 <= 4) return String(this.$t('confirm_nested_elements_few'));
      return String(this.$t('confirm_nested_elements_many'));
    }
    return n === 1
      ? String(this.$t('confirm_nested_elements_one'))
      : String(this.$t('confirm_nested_elements_many'));
  }

  private getConfirmPopupCenterPosition(): { x: number; y: number } {
    return {
      x: Math.max(12, Math.round(window.innerWidth / 2 - 120)),
      y: Math.max(12, Math.round(window.innerHeight / 2 - 60)),
    };
  }

  private closeConfirmPopup() {
    this.confirmPopup.show = false;
    this.confirmPopup.questionHtml = "";
    this.confirmPopup.confirmLabel = undefined;
    this.confirmPopup.cancelLabel = undefined;
    this.confirmPopup.onConfirm = () => {};
    this.confirmPopup.onCancel = () => {};
  }

  /** Экранирование текста для безопасной вставки в questionHtml (v-html). */
  private escapeHtml(s: string): string {
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  /** Оборачивает текст в жирный фрагмент (вес как у обычного highlight — 600). */
  private boldHtml(s: string): string {
    return `<span style="font-weight:600">${this.escapeHtml(s)}</span>`;
  }

  private openConfirmPopup(params: {
    title: string;
    question: string;
    highlight?: string;
    questionHtml?: string;
    confirmLabel?: string;
    cancelLabel?: string;
    position?: { x: number; y: number };
    onConfirm: () => void;
  }) {
    this.confirmPopup.title = params.title;
    this.confirmPopup.question = params.question;
    this.confirmPopup.highlight = params.highlight ?? "";
    this.confirmPopup.questionHtml = params.questionHtml ?? "";
    this.confirmPopup.position = params.position ?? this.getConfirmPopupCenterPosition();
    this.confirmPopup.confirmLabel = params.confirmLabel;
    this.confirmPopup.cancelLabel = params.cancelLabel;
    this.confirmPopup.onConfirm = () => {
      this.closeConfirmPopup();
      params.onConfirm();
    };
    this.confirmPopup.onCancel = () => {
      this.closeConfirmPopup();
    };
    this.confirmPopup.show = true;
  }

  onDeleteSelected(identities: any[], anchorPos?: { x: number; y: number }) {
    if (!this.genstore || !identities?.length) return;
    const vl = this.$refs.virtualListRef as any;
    const displayCount = vl?.effectiveSelectedCount ?? identities.length;

    const doDelete = () => {
      // Если среди удаляемых есть текущий выбранный элемент или его родитель
      // (либо корень поддерева, в котором они лежат) — сбрасываем выделение РОВНО так же,
      // как при ручном «отщёлке» (см. onItemSelected с clearSelection: true). Это важно,
      // чтобы plus-меню/таблица/настройки не продолжали показывать удалённый элемент.
      if (this.shouldResetSelectionForDeletion(identities)) {
        this.genstore.clearCurrentSelection();
      }
      this.genstore.deleteEntities(identities);
      const vlRef = this.$refs.virtualListRef as any;
      if (vlRef) vlRef.exitSelectionMode();
    };

    // Одиночное удаление: текст зависит от числа вложенных. effectiveSelectedCount уже
    // включает сам элемент + всех его потомков, поэтому число вложенных = displayCount - 1.
    if (identities.length === 1) {
      const single = identities[0];
      let name = single?.CombinedName || single?.Name || "";
      if (!name) {
        const fi = (vl?.flatItems ?? []).find((f: any) => this.identityEquals(single, f.item));
        name = fi?.item?.CombinedName || fi?.item?.Name || "";
      }
      const nested = Math.max(0, displayCount - 1);
      if (nested > 0) {
        // Имя (в кавычках) и число — жирным; имя экранируется внутри boldHtml. Рендерится через questionHtml (v-html).
        const questionHtml = String((this.$t as any)("confirm_delete_single_with_nested", {
          name: this.boldHtml(`«${name}»`),
          count: this.boldHtml(String(nested)),
          nestedLabel: this.pluralizeNested(nested),
        }));
        this.openConfirmPopup({
          title: String(this.$t("confirm_delete_element_title")),
          question: "",
          questionHtml,
          position: anchorPos ?? this.getConfirmPopupCenterPosition(),
          onConfirm: doDelete,
        });
      } else {
        this.openConfirmPopup({
          title: String(this.$t("confirm_delete_element_title")),
          question: String(this.$t("confirm_delete_prefix")),
          highlight: `${String(this.$t("confirm_delete_single_element_label"))} «${name}»`,
          position: anchorPos ?? this.getConfirmPopupCenterPosition(),
          onConfirm: doDelete,
        });
      }
      return;
    }

    // Массовое удаление (>1 реально удаляемых) — прежний суммарный текст.
    this.openConfirmPopup({
      title: String(this.$t("confirm_delete_elements_title")),
      question: String(this.$t("confirm_delete_prefix")),
      highlight: `${displayCount} ${this.pluralizeElements(displayCount)}`,
      position: anchorPos ?? this.getConfirmPopupCenterPosition(),
      onConfirm: doDelete,
    });
  }

  /**
   * Проверяет, нужно ли сбросить текущее выделение перед удалением переданных элементов.
   * Сброс — если current или parent СОВПАДАЕТ с одним из удаляемых, либо лежит ВНУТРИ
   * поддерева удаляемого. Сравнение identity сделано прямо здесь, без вызова actions стора —
   * это исключает любые потенциальные проблемы с Pinia/реактивными прокси и точно совпадает
   * с тем, как сравниваются элементы в selectElement/deleteElement (см. general.ts).
   */
  private identityFields(node: any): { elType: any; FolderId: any; Id: any; SrcType: any; DestType: any; ElementId: any } | null {
    if (!node || node.elType == null) return null;
    return {
      elType: node.elType,
      FolderId: node.FolderId,
      Id: node.Id,
      SrcType: node.SrcType,
      DestType: node.DestType,
      ElementId: node.ElementId,
    };
  }

  private identityEquals(a: any, b: any): boolean {
    const A = this.identityFields(a);
    const B = this.identityFields(b);
    if (!A || !B) return false;
    if (A.elType !== B.elType) return false;
    if (A.elType === BaseItemTypes.FOLDER) {
      return !!A.FolderId && A.FolderId === B.FolderId;
    }
    const srcEq = (A.SrcType != null) ? A.SrcType === B.SrcType : !B.SrcType;
    const elIdEq = (!A.ElementId && !B.ElementId) || A.ElementId === B.ElementId;
    return A.Id === B.Id && srcEq && A.DestType === B.DestType && elIdEq;
  }

  private isIdentityInSubtreeLocal(identity: any, root: any): boolean {
    if (!identity || identity.elType == null || !root) return false;
    const childKeys = ['FolderChildren', 'ChildSelections', 'ChildProjections', 'Charts', 'ChildReportElements'];
    const walk = (node: any): boolean => {
      if (!node) return false;
      if (this.identityEquals(identity, node)) return true;
      for (const key of childKeys) {
        const arr = (node as any)[key];
        if (Array.isArray(arr)) {
          for (const child of arr) {
            if (walk(child)) return true;
          }
        }
      }
      return false;
    };
    return walk(root);
  }

  shouldResetSelectionForDeletion(items: any[]): boolean {
    if (!this.genstore || !items?.length) return false;
    const current = this.genstore.selectedItem as any;
    const currentParent = this.genstore.selectedItemParent as any;
    const hasCurrent = !!current && current.elType != null;
    const hasParent = !!currentParent && currentParent.elType != null;
    if (!hasCurrent && !hasParent) return false;
    for (const item of items) {
      if (!item) continue;
      if (hasCurrent && this.identityEquals(current, item)) return true;
      if (hasParent && this.identityEquals(currentParent, item)) return true;
      if (hasCurrent && this.isIdentityInSubtreeLocal(current, item)) return true;
      if (hasParent && this.isIdentityInSubtreeLocal(currentParent, item)) return true;
    }
    return false;
  }

  /** Рекурсивно считает количество вложенных элементов узла (по всем дочерним массивам поддерева). */
  private countNestedDescendants(node: any): number {
    if (!node) return 0;
    const childKeys = ['FolderChildren', 'ChildSelections', 'ChildProjections', 'Charts', 'ChildReportElements'];
    let count = 0;
    for (const key of childKeys) {
      const arr = node[key];
      if (Array.isArray(arr)) {
        for (const child of arr) {
          count += 1 + this.countNestedDescendants(child);
        }
      }
    }
    return count;
  }

  onRequestItemDelete(arg: any, anchorPos?: { x: number; y: number }) {
    if (!arg) return;
    const itemName = arg?.CombinedName || arg?.Name || "";
    const nested = this.countNestedDescendants(arg);
    if (nested > 0) {
      // Имя (в кавычках) и число — жирным; имя экранируется внутри boldHtml. Рендерится через questionHtml (v-html).
      const questionHtml = String((this.$t as any)("confirm_delete_single_with_nested", {
        name: this.boldHtml(`«${itemName}»`),
        count: this.boldHtml(String(nested)),
        nestedLabel: this.pluralizeNested(nested),
      }));
      this.openConfirmPopup({
        title: String(this.$t("confirm_delete_element_title")),
        question: "",
        questionHtml,
        position: anchorPos ?? this.getConfirmPopupCenterPosition(),
        onConfirm: () => this.onItemDeleted(arg),
      });
      return;
    }
    this.openConfirmPopup({
      title: String(this.$t("confirm_delete_element_title")),
      question: String(this.$t("confirm_delete_prefix")),
      highlight: `${String(this.$t("confirm_delete_single_element_label"))} «${itemName}»`,
      position: anchorPos ?? this.getConfirmPopupCenterPosition(),
      onConfirm: () => this.onItemDeleted(arg),
    });
  }

  onItemDeleted(arg: any) {
    if (this.genstore && arg) {
      // Если удаляется текущий выбранный элемент (или его родитель, или родительская папка/выборка) —
      // сбрасываем выделение РОВНО тем же вызовом, что и при ручном «отщёлке» в onItemSelected.
      // Это гарантированно очищает таблицу/настройки/верхнее plus-меню. Условие — только когда
      // удаление действительно относится к текущему выделению (по требованию: «не после удаления любого»).
      if (this.shouldResetSelectionForDeletion([arg])) {
        this.genstore.clearCurrentSelection();
      }

      if (!(arg as BaseListItem).ElementId) {
        // console.log("deleting item");
        // console.log(arg);

        this.genstore.applyElementAction(arg, "delete");
      } else {
        // console.log("deleting from report");
        // console.log(arg);

        const request: AnalyticsRequestData = {
          id: arg.ElementId,
          newParentCombinedName: arg.CombinedName,
          type: arg.elType,
          kind: getIdentityKind(arg),
        };
        this.genstore.deleteReportElement(request);
      }
    }
  }

  onItemCloned(arg: any) {
    if (this.genstore) {
      this.genstore.applyElementAction(arg, "clone");
    }
  }

  async plusCreateFolder() {
    const sel = this.genstore.selectedItem;
    let parentIdentity: any | null = null;
    let parentFolderId: number | undefined;

    if (sel && sel.elType === BaseItemTypes.FOLDER && sel.FolderId) {
      parentFolderId = sel.FolderId;
      parentIdentity = { elType: BaseItemTypes.FOLDER, FolderId: sel.FolderId };
    } else if (sel && sel.elType === BaseItemTypes.SELECTION) {
      const parent = this.genstore.selectedItemParent;
      parentFolderId = parent && parent.FolderId ? parent.FolderId : undefined;
      parentIdentity = parentFolderId ? { elType: BaseItemTypes.FOLDER, FolderId: parentFolderId } : null;
    }

    const vl = (this.$refs as any).virtualListRef;
    const pos = vl?.calcOptimalInsertPosition?.(parentIdentity, BaseItemTypes.FOLDER) ?? 0;
    console.log('[smartInsert] plusCreateFolder', { depth: parentIdentity ? 1 : 0, parentIdentity, position: pos });

    const result = await this.genstore.createFolder(this.rootstore.generalMode, parentFolderId, 0, this.genstore.favoriteMode);
    if (result?.newElement) {
      this.genstore.insertElementLocally(parentIdentity, result.newElement, pos);
    }
  }

  async plusCreateSelection() {
    const sel = this.genstore.selectedItem;
    const vl = (this.$refs as any).virtualListRef;

    if (sel && sel.elType === BaseItemTypes.FOLDER && sel.FolderId) {
      const parentIdentity = { elType: BaseItemTypes.FOLDER, FolderId: sel.FolderId };
      const pos = vl?.calcOptimalInsertPosition?.(parentIdentity, BaseItemTypes.SELECTION) ?? 0;
      console.log('[smartInsert] plusCreateSelection (in folder)', { depth: 1, parentIdentity, position: pos });

      const result = await this.genstore.createRootSelection(this.rootstore.generalMode, 0, sel.FolderId, this.genstore.favoriteMode);
      if (result?.newElement) {
        this.genstore.insertElementLocally(parentIdentity, result.newElement, pos);
      }
    } else if (sel && sel.elType === BaseItemTypes.SELECTION && sel.Id) {
      const parentIdentity = { elType: sel.elType, Id: sel.Id, SrcType: sel.SrcType, DestType: sel.DestType };
      const pos = vl?.calcOptimalInsertPosition?.(parentIdentity, BaseItemTypes.SELECTION) ?? 0;
      console.log('[smartInsert] plusCreateSelection (in selection)', { depth: 'child', parentIdentity, position: pos });

      const request: AnalyticsRequestData = {
        id: 0,
        newParentId: sel.Id,
        newParentCombinedName: sel.CombinedName,
        type: BaseItemTypes.SELECTION,
        setFavorite: this.genstore.favoriteMode,
        destinationType: this.rootstore.generalMode,
        newParentType: sel.elType,
        newParentSourceType: sel.SrcType,
        newParentKind: AnalyticsElementKind.Selection,
      };
      const result = await this.genstore.createChild(request);
      if (result?.newElement) {
        this.genstore.insertElementLocally(parentIdentity, result.newElement, pos);
      }
    } else {
      const pos = vl?.calcOptimalInsertPosition?.(null, BaseItemTypes.SELECTION) ?? 0;
      console.log('[smartInsert] plusCreateSelection (root)', { depth: 0, parentIdentity: null, position: pos });

      const result = await this.genstore.createRootSelection(this.rootstore.generalMode, 0, undefined, this.genstore.favoriteMode);
      if (result?.newElement) {
        this.genstore.insertElementLocally(null, result.newElement, pos);
      }
    }
  }

  resetAllFilters() {
    this.setstore.resetAllCurrentFilters();
  }

  async getQueryResult(force_recalc: boolean = true) {
    if (
      this.genstore.selectedItem.elType === BaseItemTypes.BAR_CHART ||
      this.genstore.selectedItem.elType === BaseItemTypes.PIE_CHART ||
      this.genstore.selectedItem.elType === BaseItemTypes.GRAPH
    ) {
      const request = {
        ChartIdentity: {
          ChartId: this.genstore.selectedItem.Id,
          ChartType:
            this.genstore.selectedItem.elType === 2
              ? AnalyticsV2ChartType.Linear
              : this.genstore.selectedItem.elType === 3
              ? AnalyticsV2ChartType.Pie
              : AnalyticsV2ChartType.Bar,
          Destination: this.genstore.selectedItem.DestType,
        } as AnalyticsChartIdentity,
        ForceRecalculate: force_recalc ? true : false,
      };
      if (this.old_arg !== this.genstore.selectedItem) {
        this.old_arg = this.genstore.selectedItem;
      }

      this.querystore.getResultGraph(request);
    } else if (
      this.genstore.selectedItem.elType === BaseItemTypes.SELECTION ||
      this.genstore.selectedItem.elType === BaseItemTypes.PROJECTION ||
      this.genstore.selectedItem.elType === BaseItemTypes.LIST
    ) {
      if (force_recalc /*this.old_arg === this.genstore.selectedItem*/) {
        this.pagination.recalculate = true;
        this.pagination.forceInitial = false;
        this.pagination.offset = 0;
        this.pagination.sortMode = 0;
        this.pagination.OrderByPinned = false;

        // reset selection
        this.selectedEntities = [];
        this.selectedAll = "none";
        this.unselectedEntities = [];
      } else {
        this.old_arg = this.genstore.selectedItem;
      }

      if (localStorage.rowcount) {
        const countObjectStored = JSON.parse(localStorage.rowcount);
        const countStored =
          countObjectStored[
            "tbl_" +
              this.genstore.selectedItem.Id +
              "_" +
              this.genstore.selectedItem.DestType +
              "_" +
              this.genstore.selectedItem.SrcType
          ];

        if (countStored) {
          this.pagination.count = countStored;
          this.auxstore.setTableRowCount(countStored);
        } else {
          this.pagination.count = Number(this.auxstore.getDefaultRowCount);
          this.auxstore.setTableRowCount(this.auxstore.getDefaultRowCount);
        }
      } else {
        this.pagination.count = Number(this.auxstore.getDefaultRowCount);
        this.auxstore.setTableRowCount(this.auxstore.getDefaultRowCount);
      }

      await this.querystore.getResultTable(
        this.genstore.selectedItem,
        this.pagination,
        false
      );
      // recalc — одноразовый серверный флаг: после загрузки всегда сбрасываем,
      // иначе он залипает в общем объекте pagination и портит следующие запросы.
      this.pagination.recalculate = false;
      this.pagination.total_count = +this.querystore.getCurrentTable?.Count;
      this.pagination.OrderByPinned = this.querystore.getCurrentTable?.PinnedOptions?.OrderByPinned ?? false;

      const pinned2 = this.querystore.getCurrentTable?.PinnedOptions
      if (pinned2) {
        this.selectedEntities = pinned2.TakeAll
          ? []
          : pinned2.PinnedEntities || [];
        this.selectedAll = !pinned2.TakeAll
          ? "none"
          : pinned2.PinnedEntities?.length
          ? "many"
          : "all";
        this.unselectedEntities = pinned2.TakeAll
          ? pinned2.PinnedEntities || []
          : [];
      }
    } else if (this.genstore.selectedItem.elType === BaseItemTypes.REPORT) {
      // Если дети отчёта ещё подгружаются — Refresh и автозапросы запрещены: нечего считать.
      if ((this.genstore.selectedItem as any).isLoadingChildren) {
        return;
      }
      this.querystore.clearSettings();

      for (
        let rep = 0;
        rep < this.genstore.selectedItem.ChildReportElements.length;
        rep++
      ) {
        const rep_element = this.genstore.selectedItem.ChildReportElements[rep];

        if (
          rep_element.elType === BaseItemTypes.BAR_CHART ||
          rep_element.elType === BaseItemTypes.PIE_CHART ||
          rep_element.elType === BaseItemTypes.GRAPH
        ) {
          const request = {
            ChartIdentity: {
              ChartId: rep_element.Id,
              ChartType:
                rep_element.elType === 2
                  ? AnalyticsV2ChartType.Linear
                  : rep_element.elType === 3
                  ? AnalyticsV2ChartType.Pie
                  : AnalyticsV2ChartType.Bar,
              Destination: rep_element.DestType,
            } as AnalyticsChartIdentity,
            ForceRecalculate: true,
          };
          await this.querystore.getResultGraph(request, true, rep_element);
        } else if (
          rep_element.elType === BaseItemTypes.SELECTION ||
          rep_element.elType === BaseItemTypes.PROJECTION ||
          rep_element.elType === BaseItemTypes.LIST
        ) {
          await this.querystore.getResultTable(
            rep_element,
            {
              offset: 0,
              initial: true,
              count: Number(this.auxstore.getTableRowCount),
              recalculate: true,
              sortMode: 0,
              OrderByPinned: false,
              report_index: rep,
            },
            true
          );
        } else if (rep_element.elType === BaseItemTypes.BREAK) {
          this.querystore.pushToReport(rep_element);
        }

        // console.log(this.querystore.getCurrentReport)
      }
    }
  }

  async addChildSelection(params: any) {
    console.log("genmode: " + this.rootstore.generalMode);
    const hp = params.hoverParams;
    const vl = (this.$refs as any).virtualListRef;

    if (hp.elType === BaseItemTypes.FOLDER) {
      const parentIdentity = { elType: BaseItemTypes.FOLDER, FolderId: hp.folderId };
      const pos = vl?.calcOptimalInsertPosition?.(parentIdentity, BaseItemTypes.SELECTION) ?? 0;
      console.log('[smartInsert] addChildSelection (in folder)', { depth: 1, parentIdentity, position: pos });

      const result = await this.genstore.createRootSelection(this.rootstore.generalMode, 0, hp.folderId, this.genstore.favoriteMode);
      if (result?.newElement) {
        this.genstore.insertElementLocally(parentIdentity, result.newElement, pos);
      }
      return;
    }

    const parentIdentity = { elType: hp.elType, Id: hp.id, SrcType: hp.sourceDataType, DestType: hp.destinationDataType };
    const pos = vl?.calcOptimalInsertPosition?.(parentIdentity, BaseItemTypes.SELECTION) ?? 0;
    console.log('[smartInsert] addChildSelection (in element)', { depth: 'child', parentIdentity, position: pos });

    const request: AnalyticsRequestData = {
      id: 0,
      newParentId: hp.id,
      newParentCombinedName: hp.CombinedName,
      type: BaseItemTypes.SELECTION,
      setFavorite: this.genstore.favoriteMode,
      destinationType: this.rootstore.generalMode,
      newParentType: hp.elType,
      newParentSourceType: hp.sourceDataType,
      newParentKind:
        hp.elType === 0
          ? AnalyticsElementKind.Selection
          : hp.elType === 1
          ? AnalyticsElementKind.Projection
          : AnalyticsElementKind.List,
    };

    const result = await this.genstore.createChild(request);
    if (result?.newElement) {
      this.genstore.insertElementLocally(parentIdentity, result.newElement, pos);
    }
  }

  addToReport() {
    if (this.genstore && this.itemToReport) {
      this.genstore.addEntityToReport({
        id: this.itemToReport.Id,
        type: this.itemToReport.elType,
        sourceType: this.itemToReport.SrcType,
        destinationType: this.itemToReport.DestType,
        newParentCombinedName: '',
        reportIds: this.reportIdsModel.map((el) => el.Id),
      });
    }
  }

  async addChildChart(params: any) {
    console.log("genmode: " + this.rootstore.generalMode);
    const hp = params.hoverParams;
    const vl = (this.$refs as any).virtualListRef;
    const newChartElType = hp.chartType as BaseItemTypes;

    if (hp.elType === BaseItemTypes.FOLDER) {
      const parentIdentity = { elType: BaseItemTypes.FOLDER, FolderId: hp.folderId };
      const pos = vl?.calcOptimalInsertPosition?.(parentIdentity, newChartElType) ?? 0;
      console.log('[smartInsert] addChildChart (in folder)', { depth: 1, parentIdentity, position: pos, chartElType: newChartElType });

      const chartType =
        hp.chartType === BaseItemTypes.GRAPH
          ? AnalyticsV2ChartType.Linear
          : hp.chartType === BaseItemTypes.PIE_CHART
          ? AnalyticsV2ChartType.Pie
          : AnalyticsV2ChartType.Bar;

      const result = await this.genstore.createRootChart(hp.folderId, this.rootstore.generalMode, chartType, this.genstore.favoriteMode);
      if (result?.newElement) {
        this.genstore.insertElementLocally(parentIdentity, result.newElement, pos);
      }
      return;
    }

    const parentIdentity = { elType: hp.elType, Id: hp.id, SrcType: hp.sourceDataType, DestType: hp.destinationDataType };
    const pos = vl?.calcOptimalInsertPosition?.(parentIdentity, newChartElType) ?? 0;
    console.log('[smartInsert] addChildChart (in element)', { depth: 'child', parentIdentity, position: pos, chartElType: newChartElType });

    const request: AnalyticsRequestData = {
      id: 0,
      newParentId: hp.id,
      newParentCombinedName: hp.CombinedName,
      type: hp.chartType,
      setFavorite: this.genstore.favoriteMode,
      destinationType: this.rootstore.generalMode,
      newParentType: hp.elType,
      newParentSourceType: hp.sourceDataType,
      newParentKind:
        hp.elType === 0
          ? AnalyticsElementKind.Selection
          : hp.elType === 1
          ? AnalyticsElementKind.Projection
          : AnalyticsElementKind.List,
    };

    const result = await this.genstore.createChildChart(request);
    if (result?.newElement) {
      this.genstore.insertElementLocally(parentIdentity, result.newElement, pos);
    }
  }

  async addChildFolder(params: any) {
    const hp = params.hoverParams;
    const parentFolderId = Number(hp.folderId ?? 0);
    if (this.pendingCreateFolderByParent[parentFolderId]) {
      return;
    }

    const parentIdentity = { elType: BaseItemTypes.FOLDER, FolderId: parentFolderId };
    const vl = (this.$refs as any).virtualListRef;
    const pos = vl?.calcOptimalInsertPosition?.(parentIdentity, BaseItemTypes.FOLDER) ?? 0;
    console.log('[smartInsert] addChildFolder', { depth: 1, parentIdentity, position: pos });

    this.pendingCreateFolderByParent[parentFolderId] = true;
    try {
      const result = await this.genstore.createFolder(this.rootstore.generalMode, parentFolderId, 0, this.genstore.favoriteMode);
      if (result?.newElement) {
        this.genstore.insertElementLocally(parentIdentity, result.newElement, pos);
      }
    } finally {
      delete this.pendingCreateFolderByParent[parentFolderId];
    }
  }

  async addChildProjection(params: any) {
    const hp = params.hoverParams;
    const parentIdentity = { elType: hp.elType, Id: hp.id, SrcType: hp.sourceDataType, DestType: hp.destinationDataType };
    const vl = (this.$refs as any).virtualListRef;
    const pos = vl?.calcOptimalInsertPosition?.(parentIdentity, BaseItemTypes.PROJECTION) ?? 0;
    console.log('[smartInsert] addChildProjection', { depth: 'child', parentIdentity, position: pos });

    const request: AnalyticsRequestData = {
      id: 0,
      newParentId: hp.id,
      type: BaseItemTypes.PROJECTION,
      setFavorite: this.genstore.favoriteMode,
      destinationType: params.pr_type,
      newParentCombinedName: hp.CombinedName,
      newParentType: hp.elType,
      newParentSourceType: hp.sourceDataType,
      newParentDestinationType: hp.destinationDataType,
      newParentKind:
        hp.elType === 0
          ? AnalyticsElementKind.Selection
          : hp.elType === 1
          ? AnalyticsElementKind.Projection
          : AnalyticsElementKind.List,
    };

    const result = await this.genstore.createChild(request);
    if (result?.newElement) {
      this.genstore.insertElementLocally(parentIdentity, result.newElement, pos);
    }
  }

  async addChildList() {
    if (!this.tempListBase) {
      return;
    }

    const hp = this.tempListBase.hoverParams;
    // hp — исходная выборка, на основе которой строится список (уходит в API как основа).
    const sourceIdentity = { elType: hp.elType, Id: hp.id, SrcType: hp.sourceDataType, DestType: hp.destinationDataType };
    // Контейнер для списка — это не сама выборка, а папка, в которой она лежит, либо корень.
    const containerIdentity = this.genstore.findNearestFolderIdentity(sourceIdentity);
    const vl = (this.$refs as any).virtualListRef;
    const pos = vl?.calcOptimalInsertPosition?.(containerIdentity, BaseItemTypes.LIST) ?? 0;
    console.log('[smartInsert] addChildList', { depth: 'child', sourceIdentity, containerIdentity, position: pos });

    const request: AnalyticsRequestData = {
      id: 0,
      newParentId: hp.id,
      type: BaseItemTypes.LIST,
      setFavorite: this.genstore.favoriteMode,
      destinationType: this.tempListBase.pr_type,
      newParentCombinedName: hp.CombinedName,
      newParentType: hp.elType,
      newParentSourceType: hp.sourceDataType,
      newParentDestinationType: hp.destinationDataType,
      newParentKind:
        hp.elType === 0
          ? AnalyticsElementKind.Selection
          : hp.elType === 1
          ? AnalyticsElementKind.Projection
          : AnalyticsElementKind.List,
    };

    const result = await this.genstore.createChild(request);
    if (result?.newElement) {
      this.genstore.insertElementLocally(containerIdentity, result.newElement, pos);
    }
  }

  setup() {
    return {};
  }

  moveCard(arg: any) {
    if (this.genstore) {
      this.genstore.moveItems(arg);
    }
  }

  moveColumnItem(arg: any) {
    if (this.genstore) {
      console.log("reorder");
      this.setstore.reorderColumns(arg);
    }
  }

  async onColumnSelected(arg: any) {
    if (this.genstore) {
      await this.setstore.updateColumnSelection(arg);
      this.reloadNameContainer();
    }
  }

  onTogglesChange(arg: any) {
    console.log("update toggles");
    if (this.genstore && this.setstore) {
      this.setstore.updateColumnSettings(this.genstore.selectedItem, true);
    }
  }

  onRangeChange(arg: any) {
    console.log("update range");
    console.log(arg);

    if (this.genstore && this.setstore) {
      this.setstore.updateColumnDateRange(arg);
    }
  }

  async moveStoreItem(params: any) {
    if (!this.genstore) return;
    // Лок на перетаскиваемом элементе на время запроса (грей-аут + блок). In-memory swap уже выполнен через cardMoved.
    const movedKey = this.makeElementLockKey(params.dragParams);
    if (params.dragParams.parent_type !== BaseItemTypes.REPORT) {
      const request: AnalyticsRequestData = {
        id: params.item_id,
        type: params.dragParams.elType,
        newParentCombinedName: params.dragParams.CombinedName,
        destinationType: params.dragParams.destinationDataType,
        sourceType: params.dragParams.sourceDataType,
        oldPosition: params.old_pos,
        newPosition: params.new_pos,
        oldParentId: params.dragParams.parent_id,
        oldParentType: params.dragParams.parent_type,
        kind:
          params.dragParams.elType === 0
            ? AnalyticsElementKind.Selection
            : params.dragParams.elType === 1
            ? AnalyticsElementKind.Projection
            : AnalyticsElementKind.List,
        newParentKind:
          params.dragParams.parent_type === 0
            ? AnalyticsElementKind.Selection
            : params.dragParams.parent_type === 1
            ? AnalyticsElementKind.Projection
            : AnalyticsElementKind.List,
      };
      this.setMoveLocks([movedKey]);
      try {
        await this.genstore.changePosition(request);
      } finally {
        this.clearMoveLocks([movedKey]);
      }
    } else {
      const request: AnalyticsRequestData = {
        id: params.dragParams.innerElementId,
        newParentCombinedName: params.dragParams.CombinedName,
        type: params.dragParams.elType,
        newPosition: params.new_pos,
        oldParentId: params.dragParams.parent_id,
        oldParentType: params.dragParams.parent_type,
        kind:
          params.dragParams.elType === 0
            ? AnalyticsElementKind.Selection
            : params.dragParams.elType === 1
            ? AnalyticsElementKind.Projection
            : AnalyticsElementKind.List,
      };
      this.setMoveLocks([movedKey]);
      try {
        await this.genstore.changeReportElementPosition(request);
      } finally {
        this.clearMoveLocks([movedKey]);
      }
    }
  }

  moveFormulaItem(params: any) {
    if (this.setstore) {
      // console.log(params);
      this.setstore.changeFormulaPosition(
        this.genstore.selectedItem,
        params.dragParams.innerElementId,
        params.old_pos,
        params.new_pos
      );
    }
  }

  setDefSettingsClick() {
    if (this.setstore) {
      this.setstore.setDefaultColumnSettings(this.genstore.selectedItem);
    }
  }

  /** Собирает request для перемещения: цель — корень (moveTargetKind 'root'), папка или табличный элемент.
   * При активном мульти-выделении отправляет все реально выбранные элементы одним запросом. */
  moveItemToParent(params: any) {
    if (!this.genstore) return;
    const drag = params.dragParams;
    const hover = params.hoverParams;
    const moveTargetKind = params.moveTargetKind ?? (hover.elType === BaseItemTypes.FOLDER ? 'folder' : 'table');
    const isRootDrop = moveTargetKind === 'root';
    const targetLabel = isRootDrop
      ? String(this.$t("confirm_move_target_root"))
      : (hover?.CombinedName || hover?.Name || String(this.$t("confirm_move_target_root")));
    const popupPosition = params?.dropPosition && Number.isFinite(params.dropPosition.x) && Number.isFinite(params.dropPosition.y)
      ? { x: Number(params.dropPosition.x), y: Number(params.dropPosition.y) }
      : undefined;

    // Мульти-перемещение: если активен режим выделения и есть выбранные элементы
    const vl = (this.$refs as any).virtualListRef;
    if (vl?.selectionMode && vl?.selectedItems?.size > 0) {
      const selectedArr = typeof vl.getSelectedIdentities === 'function'
        ? vl.getSelectedIdentities()
        : Array.from(vl.selectedItems.values());
      const displayCount = vl.effectiveSelectedCount ?? selectedArr.length;
      const doMove = async () => {
        // Очищаем мультивыбор только после подтверждения переноса (Cancel выбор не трогает).
        if (vl?.selectedItems?.size > 0) {
          vl.selectedItems.clear();
        }
        const targetKey = this.makeElementLockKey(hover);
        const movedKeys = selectedArr.map((el: any) => this.makeElementLockKey(el));
        const lockKeys = [targetKey, ...movedKeys];
        this.setMoveLocks(lockKeys);
        try {
          const res = await this.genstore.changeChildrenParent(selectedArr, hover, moveTargetKind);
          if (res?.errorMessage) {
            const q = (this as any).$q;
            if (q?.notify) q.notify({ message: res.errorMessage, type: 'warning' });
          }
        } finally {
          this.clearMoveLocks(lockKeys);
        }
      };
      this.openConfirmPopup({
        title: String(this.$t("confirm_move_elements_title")),
        question: String(this.$t("confirm_move_prefix")),
        highlight: `${displayCount} ${this.pluralizeElements(displayCount)} ${String(this.$t("confirm_move_to"))} «${targetLabel}»`,
        position: popupPosition,
        onConfirm: doMove,
      });
      return;
    }

    // Одиночное перемещение.
    // Для папок Id = 0, реальный идентификатор — FolderId; для остальных — Id.
    const dragItemId = drag.elType === BaseItemTypes.FOLDER
      ? Number(drag.folderId)
      : (Number(params.item_id) || drag.id);
    const request: AnalyticsRequestData = {
      id: dragItemId,
      type: drag.elType,
      sourceType: drag.sourceDataType,
      destinationType: drag.destinationDataType,
      newParentType: hover.elType,
      newParentCombinedName: hover.CombinedName ?? '',
      newParentSourceType: hover.sourceDataType,
      newParentDestinationType: hover.destinationDataType,
      newPosition: params.new_pos,
      newParentId: hover.elType === BaseItemTypes.FOLDER ? undefined : (hover.id != null ? Number(hover.id) : undefined),
      kind: drag.elType === BaseItemTypes.SELECTION ? AnalyticsElementKind.Selection
        : drag.elType === BaseItemTypes.PROJECTION ? AnalyticsElementKind.Projection
          : AnalyticsElementKind.List,
      newParentKind: hover.elType === BaseItemTypes.SELECTION ? AnalyticsElementKind.Selection
        : hover.elType === BaseItemTypes.PROJECTION ? AnalyticsElementKind.Projection
          : hover.elType === BaseItemTypes.LIST ? AnalyticsElementKind.List
            : undefined,
      moveTargetKind,
      targetFolderId: moveTargetKind === 'folder' ? (hover.folderId != null ? Number(hover.folderId) : undefined) : undefined,
      targetSegment: moveTargetKind === 'folder' ? hover.destinationDataType : undefined,
      isRoot: drag.isRoot,
      parentType: drag.parent_type,
      movedFolderId: drag.elType === BaseItemTypes.FOLDER ? (drag.folderId != null ? Number(drag.folderId) : undefined) : undefined,
    };
    const doMove = async () => {
      const targetKey = this.makeElementLockKey(hover);
      const movedKey = this.makeElementLockKey(drag);
      const lockKeys = [targetKey, movedKey];
      this.setMoveLocks(lockKeys);
      try {
        const res = await this.genstore.changeChildParent(request);
        if (res?.errorMessage) {
          const q = (this as any).$q;
          if (q?.notify) q.notify({ message: res.errorMessage, type: 'warning' });
        }
      } finally {
        this.clearMoveLocks(lockKeys);
      }
    };
    this.openConfirmPopup({
      title: String(this.$t("confirm_move_elements_title")),
      question: String(this.$t("confirm_move_prefix")),
      highlight: `1 ${this.pluralizeElements(1)} ${String(this.$t("confirm_move_to"))} «${targetLabel}»`,
      position: popupPosition,
      onConfirm: doMove,
    });
  }
}
</script>

<style lang="scss">
@import url("@/styles/fonts.scss");

.analytics-layout .q-drawer--left.fixed {
  top: 56px;
}

/* Layout лежит внутри .app-content (App.vue): в колоночном .app-shell высотой 100vh
   шапка (56px, flex-shrink:0) занимает свои 56px сверху, а .app-content забирает остаток.
   Layout должен точно вписаться в .app-content, поэтому height = окно минус шапка.
   ВАЖНО: QLayout сам вешает ИНЛАЙНОВЫЙ min-height = высота окна ($q.screen.height) в px.
   Инлайн бьёт класс, поэтому без !important layout всегда не ниже полного окна и на 56px
   вылезает за .app-content (уходит под шапку). min-height:0 !important гасит этот инлайн,
   высоту держит height. Дальше высота идёт по цепочке: q-layout -> внешний q-splitter. */
.analytics-layout.q-layout {
  height: calc(100vh - 56px);
  min-height: 0 !important;
}

.analytics-layout > .q-splitter {
  height: 100%;
}

/* Обёртка контента правой панели splitter. Раньше это были q-page-container/q-page
   Quasar: их убрали, потому что q-page считал свой min-height через JS и на кадр
   отставал от нового размера вьюпорта при ресайзе (отсюда мелькание полосы). Теперь
   min-height задан статически в CSS, поэтому высота меняется мгновенно вместе с
   вьюпортом, без кадрового «выступа». Вьюпорт для страницы: окно за вычетом шапки
   приложения (56px, она лежит вне layout). */
.analytics-page-container {
  width: 100%;
  /* Область прокрутки контента правой панели. В tz-fin окно скроллиться не может
     (.app-shell/.app-content в App.vue стоят overflow: hidden, шапка вынесена наружу
     q-layout), поэтому раньше прокрутку давал q-page-container. После перехода на div
     контейнер сам становится скролл-областью: фиксированная высота = высота .app-content
     (через height:100% по цепочке layout -> splitter -> panel), overflow-y: auto. */
  height: 100%;
  overflow-y: auto;
}

.analytics-page {
  /* Заполняем контейнер по высоте: при коротком контенте фон на весь экран, при длинном
     (графики/отчёты выше вьюпорта) страница растёт, а скроллит .analytics-page-container.
     В табличном режиме (.qpage--table-flex + .qpage--clip) страница не переполняется -
     тело таблицы скроллится внутри себя, поэтому двойного скролла нет. */
  min-height: 100%;
  /* border-box обязателен: у страницы есть inline padding 6px. Без него padding уходит
     ЗА пределы 100% высоты, и низ таблицы (обёртка flex:1 в этой странице) вылезает под
     нижнюю границу окна. С border-box padding входит в высоту и даёт нижний отступ. */
  box-sizing: border-box;
}

/* В табличном режиме переводим страницу в flex-колонку: строка действий склада
   (если есть в сегменте) занимает свою высоту сверху, а обёртка таблицы забирает
   весь остаток (flex: 1 1 0) и доводит таблицу до низа страницы. min-height
   (calc(100vh - 56px)) остаётся полом: при небольшом контенте страница ровно во
   весь экран, а длинные таблицы скроллятся внутри своего тела, не растягивая
   страницу. */
.qpage--table-flex {
  display: flex;
  flex-direction: column;
}

/* В режимах sticky/scroll за вертикальную прокрутку отвечает тело таблицы (внутренний
   скролл), поэтому страница скроллиться не должна. В режиме page класс не вешаем —
   там нужна обычная прокрутка страницы. */
.qpage--clip {
  overflow: hidden;
}

.qlayout--clip {
  /* В табличном режиме (sticky/scroll) за вертикаль отвечает тело таблицы, поэтому
     прячем переполнение самого layout, чтобы не появлялась полоса прокрутки окна.
     Высоту layout задаёт .analytics-layout.q-layout (тот же calc, но выше по
     специфичности), поэтому здесь height не дублируем. */
  overflow: hidden;
}

.qlayout--clip.q-layout {
  min-height: 0;
}

/* Пока показана таблица, прячем прокрутку самого окна (корневой html и body).
   Класс вешается на html из onClipPageScrollChange. Это финальный барьер: даже если
   какой-то контейнер на кадр выше вьюпорта, глобальная полоса не появится. Внутренняя
   прокрутка тела таблицы (.qtl-body-scroll) не затрагивается. */
html.analytics-window-clip {
  overflow: hidden;
}

html.analytics-window-clip body {
  overflow: hidden;
}

/* Тонкий скролл панели настроек — как в lite-таблице (6px, серый бегунок,
   прозрачная дорожка). Firefox. */
.settings-panels-scroll {
  scrollbar-width: thin;
  scrollbar-color: #d0d0d0 transparent;
}

.settings-panels-scroll::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.settings-panels-scroll::-webkit-scrollbar-thumb {
  background: #d0d0d0;
  border-radius: 6px;
}

.settings-panels-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.plus-context-menu {
  padding: 4px;
  border-radius: $smaller-radius;
  background: #fff;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
}

.plus-context-menu__item {
  height: 30px;
  min-height: 30px;
  padding: 6px 8px;
  border-radius: $smaller-radius;
  background: #fff;
  cursor: pointer;
}

.plus-context-menu__item {
  color: var(--Text-color-text_main);
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.plus-context-menu__item:hover {
  background-color: $secondary;
}

.plus-context-menu__sep {
  height: 1px;
  margin: 1px 0;
  background: #F2F2F2;
}

body {
  font-family: "Roboto" !important;
  color: #4d4d4d;
  letter-spacing: 0;
  font-weight: 400;
  line-height: 1;
}

.no-select-border,
.no-select-border > * {
  padding-bottom: 0 !important;

  .q-field__control {
    min-height: 30px !important;
    border-radius: 4px !important;
  }
  .q-field__control:before {
    border: 0 !important;
  }
  .q-field__control:after {
    border: 0 !important;
    height: 1px !important;
  }
  .q-field__control-container {
    padding-top: 0 !important;
  }
  .q-field__native > span {
    font-size: 13px !important;
    color: $dark !important;
  }
}

.text-medium {
  font-weight: 500;
  color: #6b6a6a !important;
}

.q-item {
  min-height: 30px !important;
  font-size: 14x !important;
  border-radius: 3px;
  // color: $dark !important;
}

.q-item > div {
  font-size: 13px !important;
}

.splitt {
  .q-splitter__before {
    transition: width 0.2s ease-out;
    width: 0px !important;
  }
}

.vertical-sep::after {
  position: absolute;
  content: "";
  width: 24px;
  height: 24px;
  right: 40px;
  top: -12px;
  background: white url("@/assets/height_48.svg") center / contain no-repeat;
  border-radius: 50%;
  border: 1px solid #dedede;
  pointer-events: none;
}

/* .download-btn {
  width: 23px;
  height: 23px;
  background: white url("./assets/download.svg") center / contain no-repeat;
  border-radius: 50%;
  opacity: 0.6;
  border: 0;
} */

.horizontal-sep::after {
  position: absolute;
  content: "";
  width: 24px;
  height: 24px;
  right: -12px;
  top: 40%;
  background: white url("@/assets/width_48.svg") center / contain no-repeat;
  border-radius: 50%;
  border: 1px solid #dedede;
  pointer-events: none;
}

.left-panel {
  padding: 10px;
}

.analytics-tabs {
  /* Таб-бар аналитики: стили по макету, точечно для этого экрана */
  --analytics-tabs-inactive-color: var(--Text-color-text-secondary, #979797);
  --analytics-tabs-active-color: var(--color-accent, #3F884F);
  --analytics-tabs-padding-top: 11px;
  --analytics-tabs-padding-bottom: 9px; /* подогнано под фактическую высоту label */

  min-height: 47px;

  .q-tabs__content {
    justify-content: flex-start;
    padding-left: 16px; /* от границы панели до первого таба */
    column-gap: 16px; /* расстояние между табами */
  }

  .q-tab {
    color: var(--analytics-tabs-inactive-color);
    font-family: Roboto, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px;
    min-height: 47px;
    padding-left: 0;
    padding-right: 0;
    background: transparent;
    flex: 0 0 auto;
    min-width: 0;
    cursor: pointer;
  }

  /* Убираем любые фоновые эффекты на hover/active/click */
  .q-tab:hover,
  .q-tab:active,
  .q-tab--active {
    background: transparent !important;
  }

  /* Quasar overlay helper, который может давать «вспышку» фона */
  .q-tab .q-focus-helper {
    opacity: 0 !important;
    background: transparent !important;
  }

  .q-tab--active {
    color: var(--analytics-tabs-active-color);
  }

  .q-tab__content {
    padding-top: var(--analytics-tabs-padding-top);
    padding-bottom: var(--analytics-tabs-padding-bottom);
    padding-left: 0;
    padding-right: 0;
  }

  .q-tab__indicator {
    height: 3px;
    background: var(--analytics-tabs-active-color);
  }
}

.list-toolbar {
  display: flex;
  align-items: center;
  padding: 7px 8px;
  border-bottom: 1px solid #D2D2D2;

  &--search {
    padding-top: 11px;
    padding-bottom: 11px;
  }
}

.toolbar-input-wrapper {
  flex: 1;
  min-width: 0;
  margin: 0 8px;
}

.toolbar-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  flex-shrink: 0;
  color: #999;

  &:hover {
    opacity: 0.7;
  }
}

.toolbar-icon-btn--accent {
  &:not(:disabled):hover {
    color: #3F884F;
    opacity: 1;
  }
}

.toolbar-icon-btn--search {
  margin-left: 8px;
}

.toolbar-icon-btn--active-add {
  color: #3F884F;
}

.toolbar-icon-btn--active-search {
  color: #3F884F;
}

.toolbar-icon-btn--fav {
  margin-left: 8px;

  &:not(:disabled):hover {
    color: #D05A4F;
    opacity: 1;
  }
}

.toolbar-icon-btn--active-fav {
  color: #D05A4F;

  &:not(:disabled):hover {
    color: #999;
  }
}

.toolbar-icon-btn--expand {
  margin-left: 16px;

  &:not(:disabled):hover {
    color: #3F884F;
    opacity: 1;
  }
}

.toolbar-icon-btn--splitter-expand {
  &:not(:disabled):hover {
    color: #3F884F;
    opacity: 1;
  }
}

.splitter-refresh-btn {
  &:not(.q-btn--disabled):not([disabled]):hover {
    color: #3F884F !important;
  }
}

.toolbar-search-input {
  width: 100%;
  font-size: small !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  border-radius: 8px !important;
  height: 32px !important;
  min-height: 32px !important;

  .q-field__control {
    height: 32px !important;
    min-height: 32px !important;
    border-radius: 8px;
    border: 1px solid var(--color-border, #D2D2D2);
    background: var(--Background-White, #FFF);
    padding: 0 12px;
  }

  .q-field__control::before,
  .q-field__control::after {
    border: none !important;
  }

  &.q-field--focused .q-field__control {
    border-color: var(--color-accent, #3F884F);
  }

  .q-field__append {
    height: 32px !important;
    padding: 0;
    align-items: center;
  }

  .q-field__inner,
  .q-field__control-container {
    height: 32px !important;
    min-height: 32px !important;
  }

  .q-field__marginal {
    height: 32px !important;
  }

  .q-field__native::placeholder {
    color: #999;
  }
}

.toolbar-segment-selector {
  /* Scoped styles are in segment.selector.vue; this ensures global q-field padding is overridden */
}

.toolbar-expand-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    opacity: 0.7;
  }

  svg {
    transition: transform 0.2s ease;
  }
}

.tooltip-header {
  border-bottom: 1px solid grey;
  max-height: 40px;
}

/* list items reorder animation */
.list-move, /* apply transition to moving elements */
.list-enter-active,
.list-leave-active {
  transition: transform 0.2s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

/* ensure leaving items are taken out of layout flow so that moving
   animations can be calculated correctly. */
.list-leave-active {
  position: absolute;
}

.q-input .q-field__control:before {
  border: 1px solid lightgrey;
  transition: none !important;
}

.q-input .q-field__control:after {
  height: inherit;
  border-radius: inherit;
  border: 1px solid lightgrey;
  transition: none !important;
}

.no-icon-chip .q-chip__icon--left {
  display: none !important;
}

.q-toggle__thumb:after {
  // padding-top: 0 !important;
  background-color: #b80f0a !important;
}

.q-toggle__thumb .q-icon {
  color: #fff !important;
}

.q-toggle__inner--truthy .q-toggle__thumb:after {
  background-color: $primary !important;
}

.container2 {
  width: calc(50% - 20px);
  height: 60vh;
  margin: 10px;
  position: relative;
  overflow: hidden;
  display: inline-block;
  border: 0;
}

.empty-label {
  background: transparent;
  font-size: 72pt;
  opacity: 0.1;
  width: 100%;
  margin-top: 150px !important;
  color: grey;
  text-align: center;
}

.container2:hover {
  border: 3px solid red;
}

.container4 {
  width: calc(25% - 20px);
  height: 40vh;
  margin: 10px;
  border-radius: 6px;
  position: relative;
  overflow: hidden;
  display: inline-block;
  border: 1px solid lightgrey;
  cursor: pointer;

  & > * {
    pointer-events: none;
  }

  &::after {
    content: ""; /* Выводим пустой блок */
    position: absolute; /* Абсолютное позиционирование */
    left: 0px;
    right: 0px; /* Устанавливает ширину блока */
    bottom: 0; /* Положение от нижнего края */
    height: 1em; /* Высота */
    background: linear-gradient(to bottom, transparent, lightgrey 100%);
    pointer-events: none; /* Не реагирует на мышь */
  }
}

body.desktop .q-checkbox:not(.disabled) .q-checkbox__inner:before {
  opacity: 0 !important;
}

.container4:hover {
  &::after {
    content: ""; /* Выводим пустой блок */
    position: absolute; /* Абсолютное позиционирование */
    left: 0px;
    right: 0px; /* Устанавливает ширину блока */
    bottom: 0; /* Положение от нижнего края */
    height: 1em; /* Высота */
    background: linear-gradient(to bottom, transparent, lightblue 100%);
    pointer-events: none; /* Не реагирует на мышь */
  }
}

.preview2 {
  transform-origin: center;
  transform: translate(-10%, -10%) scale(0.8);
}

.preview4 {
  transform-origin: center;
  transform: translate(-25%, -25%) scale(0.5);
}

.dp__theme_light {
  --dp-border-color: grey;
  --dp-input-padding: 0;
  --dp-font-size: 13px;
  --dp-primary-color: #499259 !important;
  --dp-dark-color: #9e9e9e !important;
  --dp-input-icon-padding: 25px;
}

.dp__input_icon {
  top: 48%;
}

.dp__input_icons {
  padding: 6px 6px;
}

.dp_input {
  line-height: unset !important;
}

.thin-input-date,
.thin-input-date > * {
  height: 24px !important;
  min-height: 24px !important;

  .q-field__control {
    border-radius: 4px !important;
    height: 24px !important;
    min-height: 24px !important;
    font-size: 12px;
    padding: 0 5px !important;
  }

  .q-field--dense .q-field__after,
  .q-field--dense .q-field__append {
    padding-left: 2px !important;
  }

  .q-field--highlighted {
    border-color: $secondary;
  }

  .q-field__native {
    min-height: 24px !important;
  }

  .q-field__marginal {
    height: 24px !important;
  }

  .q-field__bottom {
    font-size: 10px !important;
    padding: 5px 0 0 !important;
  }

  .q-field__native {
    padding: 0 !important;
  }

  .q-field {
    padding-top: 4px !important;
    padding-bottom: 18px !important;
  }
}
</style>
